// Το **ένα** σημείο των ελληνικών αλφαριθμητικών της διαδικτυακής εφαρμογής.
//
// Κανένα ελληνικό μήνυμα σφάλματος ή ετικέτα κατάστασης δεν γράφεται μέσα σε
// συστατικό. Ο λόγος είναι η **ΜΛΑ-02**: η ίδια έννοια πρέπει να λέγεται με τον
// ίδιο όρο στη διαδικτυακή εφαρμογή, στην επέκταση και στο πρόσθετο WordPress. Με
// τα αλφαριθμητικά σκορπισμένα σε δεκαπέντε αρχεία, η συνέπεια εξαρτάται από τη
// μνήμη του καθενός. Η επέκταση έχει το αντίστοιχο `lib/strings.js`.
//
// **Τα μηνύματα του API μένουν στα αγγλικά** κατά το `CLAUDE.md` και
// μεταφράζονται εδώ. Η μετάφραση γίνεται με βάση τον **κωδικό** της Απόφασης D4
// και, όπου χρειάζεται ακρίβεια, με βάση το αγγλικό μήνυμα: το `CONFLICT`
// σημαίνει τρία διαφορετικά πράγματα ανάλογα με τη διαδρομή, και ένα γενικό
// «υπάρχει ήδη» θα έκρυβε ποιο.

/**
 * Ταυτότητα της εργασίας.
 *
 * Ο **πλήρης** τίτλος και όχι σύντμηση: είναι ο τίτλος της διπλωματικής και
 * εμφανίζεται στην ταυτότητα της εφαρμογής, στην καρτέλα του περιηγητή και στο
 * υποσέλιδο. Η σύντμηση «Θεματική Περιήγηση» καταργήθηκε.
 */
export const APP = {
    title: 'Θεματική Περιήγηση στο Διαδίκτυο και Συνεργατική Διαχείριση Ψηφιακών Πόρων',
    // Ο **σύντομος** τίτλος, για θέσεις που κόβουν: η καρτέλα του περιηγητή δείχνει
    // περίπου είκοσι χαρακτήρες, οπότε ο πλήρης τίτλος ως επίθημα θα εξαφάνιζε και
    // τον εαυτό του και το όνομα της σελίδας. Είναι **ο ίδιος** με το όνομα που
    // χρησιμοποιεί η επέκταση (ΜΛΑ-02), και η ταύτιση ελέγχεται από δοκιμή.
    shortTitle: 'Θεματική Περιήγηση',
    author: 'Παπαδάκης Χαρίδημος - Νικόλαος του Εμμ.',
    studentId: 'Α.Μ. ΤΠ4353'
};

/**
 * Μηνύματα επιτυχίας όπου η έκβαση **δεν είναι μία** (Απόφαση D9).
 *
 * Η καταχώρηση πόρου έχει δύο επιτυχείς εκβάσεις που φαίνονται ίδιες στην οθόνη
 * και δεν είναι: στη μία δημιουργήθηκε πόρος, στην άλλη η διεύθυνση υπήρχε ήδη
 * και η συλλογή προσαρτήθηκε σε υπάρχον έγγραφο. Το «δημιουργήθηκε» θα ήταν
 * ψέμα στη δεύτερη.
 *
 * Το μήνυμα της προσάρτησης λέει **και τα δύο μισά**. Το πρώτο, ότι ο πόρος
 * υπήρχε και φέρνει μαζί την επιμέλεια άλλων. Το δεύτερο, ότι τα στοιχεία που
 * μόλις πληκτρολόγησε ο χρήστης **αγνοήθηκαν** — γιατί αυτό ακριβώς κάνει ο
 * controller, ώστε ο ένας πελάτης να μην ξαναγράφει σιωπηλά την επιμέλεια του
 * άλλου. Σιωπηλή απόρριψη εισόδου είναι η ΜΛΑ-03 που επικαλείται η ίδια η
 * απόφαση για να απορρίψει το «δημιουργήθηκε».
 */
export const RESOURCE_CREATED = {
    created: {
        title: 'Ο πόρος καταχωρήθηκε',
        body: 'Προστέθηκε στη συλλογή με τα στοιχεία που συμπληρώσατε.'
    },
    attached: {
        title: 'Ο πόρος υπήρχε ήδη και εντάχθηκε στη συλλογή',
        body:
            'Η διεύθυνση ήταν ήδη καταχωρημένη αλλού, οπότε δεν δημιουργήθηκε νέα εγγραφή: ' +
            'εντάχθηκε η υπάρχουσα, μαζί με τον τίτλο, την περιγραφή και τις ετικέτες που ' +
            'έχουν καταχωρήσει άλλοι. Ο τίτλος και η περιγραφή που συμπληρώσατε ΔΕΝ ' +
            'αποθηκεύτηκαν, ώστε να μην αντικατασταθεί η επιμέλειά τους. Αν χρειάζονται ' +
            'διόρθωση, κάντε την από την επεξεργασία του πόρου.'
    }
};

/** Ετικέτες κατάστασης. Κεφαλαίο αρχικό: είναι ετικέτες, όχι κώδικας. */
export const LABELS = {
    visibility: {
        private: 'Ιδιωτικό',
        public: 'Δημόσιο'
    },
    archived: 'Αρχειοθετημένο',
    role: {
        coordinator: 'Συντονιστής',
        member: 'Μέλος',
        admin: 'Διαχειριστής',
        guest: 'Επισκέπτης'
    }
};

/**
 * Μηνύματα ανά κωδικό σφάλματος (Απόφαση D4).
 *
 * Το `NETWORK_ERROR` και το `INVALID_RESPONSE` τα παράγει ο `apiClient`, όχι το
 * API: είναι η διάκριση που απαιτεί η **ΜΛΑ-03**, ώστε μια διακοπή δικτύου να μη
 * διαβάζεται ως λήξη συνεδρίας.
 */
const BY_CODE = {
    BAD_REQUEST: 'Το αίτημα δεν είναι έγκυρο.',
    UNAUTHORIZED: 'Απαιτείται σύνδεση.',
    FORBIDDEN: 'Δεν έχετε δικαίωμα για αυτή την ενέργεια.',
    NOT_FOUND: 'Δεν βρέθηκε.',
    CONFLICT: 'Υπάρχει ήδη.',
    VALIDATION_ERROR: 'Ελέγξτε τα στοιχεία που συμπληρώσατε.',
    RATE_LIMITED: 'Πολλές προσπάθειες. Δοκιμάστε ξανά σε λίγο.',
    INTERNAL_ERROR: 'Παρουσιάστηκε σφάλμα στον διακομιστή.',
    NOT_IMPLEMENTED: 'Η λειτουργία δεν είναι διαθέσιμη ακόμη.',
    // Απόφαση D12: σφάλματα που προέρχονται από τη **σελίδα-στόχο** και όχι από
    // το σύστημα. Ο χρήστης πρέπει να καταλάβει ότι φταίει η διεύθυνση που
    // έδωσε, αλλιώς θα δοκιμάζει ξανά την ίδια.
    UPSTREAM_ERROR: 'Η σελίδα δεν διαβάστηκε. Συμπληρώστε τα στοιχεία με το χέρι.',
    UPSTREAM_TIMEOUT: 'Η σελίδα άργησε να απαντήσει. Συμπληρώστε τα στοιχεία με το χέρι.',
    NETWORK_ERROR: 'Δεν υπάρχει σύνδεση με τον διακομιστή. Η συνεδρία σας παραμένει ενεργή.',
    INVALID_RESPONSE: 'Ο διακομιστής απάντησε σε μορφή που δεν αναγνωρίζεται.',
    UNKNOWN_ERROR: 'Παρουσιάστηκε απροσδόκητο σφάλμα.'
};

/**
 * Μηνύματα ανά αγγλικό κείμενο, για τις περιπτώσεις όπου ο κωδικός δεν αρκεί.
 *
 * Είναι **κλειστό σύνολο**: παράχθηκε από απαρίθμηση κάθε `ApiError` του `api/`.
 * Αν προστεθεί νέο μήνυμα στο API και δεν προστεθεί εδώ, εμφανίζεται το μήνυμα
 * του κωδικού — υποβαθμισμένο αλλά **πάντα ελληνικό**, ποτέ αγγλικό.
 */
const BY_MESSAGE = {
    // Ταυτοποίηση
    'Invalid email or password': 'Λανθασμένη διεύθυνση ή κωδικός.',
    'Authentication required': 'Απαιτείται σύνδεση.',
    'Missing bearer token': 'Απαιτείται σύνδεση.',
    'Invalid token': 'Η συνεδρία σας δεν είναι έγκυρη. Συνδεθείτε ξανά.',
    'Token has expired': 'Η συνεδρία σας έληξε. Συνδεθείτε ξανά.',
    'Account no longer exists': 'Ο λογαριασμός δεν υπάρχει πλέον.',
    'An account with these credentials already exists':
        'Υπάρχει ήδη λογαριασμός με αυτά τα στοιχεία.',
    'A record with these values already exists': 'Υπάρχει ήδη εγγραφή με αυτές τις τιμές.',
    'Too many attempts, please try again later':
        'Πολλές προσπάθειες σύνδεσης. Δοκιμάστε ξανά σε λίγα λεπτά.',

    // Δικαιώματα
    'Insufficient permissions': 'Δεν έχετε δικαίωμα για αυτή την ενέργεια.',
    'Administrator role required': 'Η ενέργεια απαιτεί ρόλο διαχειριστή.',
    // ΛΑ-01. **Μία** διατύπωση για τρεις αποτυχίες —άγνωστο, ληγμένο,
    // χρησιμοποιημένο— γιατί η ενέργεια του χρήστη είναι η ίδια και στις τρεις,
    // και ο διαχωρισμός τους λέει σε τρίτον αν το διακριτικό υπήρξε ποτέ.
    'Reset link is invalid or has expired':
        'Ο σύνδεσμος δεν ισχύει ή έχει λήξει. Ζητήστε νέο σύνδεσμο επαναφοράς.',
    'Password reset is not available: mail delivery is not configured':
        'Η επαναφορά κωδικού δεν είναι διαθέσιμη: η αποστολή μηνυμάτων δεν έχει ρυθμιστεί.',
    // feat/email-change — ΛΑ-02 / D45.
    //
    // **Μία διατύπωση για τρεις αποτυχίες** του συνδέσμου, με το επιχείρημα της
    // επαναφοράς αυτούσιο: η ενέργεια του χρήστη είναι η ίδια σε άγνωστο,
    // ληγμένο και χρησιμοποιημένο διακριτικό.
    'Confirmation link is invalid or has expired':
        'Ο σύνδεσμος δεν ισχύει ή έχει λήξει. Ζητήστε νέα αλλαγή διεύθυνσης από το προφίλ σας.',
    'Current password is incorrect':
        'Ο κωδικός πρόσβασης δεν είναι σωστός.',
    'The new address is the same as the current one':
        'Η νέα διεύθυνση είναι ίδια με την τρέχουσα.',
    // ⚠ **ΟΝΟΜΑΖΕΙ ΤΗΝ ΑΙΤΙΑ, ΚΑΙ ΕΙΝΑΙ ΔΗΛΩΜΕΝΗ ΕΞΑΙΡΕΣΗ.** Παντού αλλού η
    // άρνηση δεν αποκαλύπτει ύπαρξη· εδώ ο αιτών μόλις έδωσε τον κωδικό του,
    // οπότε η σιωπή δεν προστατεύει κανέναν και αφήνει τον χρήστη να περιμένει
    // μήνυμα που δεν θα έρθει ποτέ (ΜΛΑ-03).
    'This address already belongs to another account':
        'Η διεύθυνση χρησιμοποιείται ήδη από άλλον λογαριασμό.',
    'Email change is not available: mail delivery is not configured':
        'Η αλλαγή διεύθυνσης δεν είναι διαθέσιμη: η αποστολή μηνυμάτων δεν έχει ρυθμιστεί.',
    'Too many email change requests. Try again later.':
        'Πολλά αιτήματα αλλαγής διεύθυνσης. Δοκιμάστε ξανά αργότερα.',
    'Too many reset requests for this address. Try again later.':
        'Πολλά αιτήματα επαναφοράς για αυτή τη διεύθυνση. Δοκιμάστε ξανά αργότερα.',
    'You cannot revoke your own administrator role':
        'Δεν μπορείτε να αφαιρέσετε τον δικό σας ρόλο διαχειριστή.',
    // ⚠ **Το μήνυμα που έλειπε, και το κενό του δεν ήταν αθώο.** Χωρίς ρητή
    // εγγραφή, το κείμενο του χρήστη αποφασίζεται από τον **κωδικό**: η άρνηση
    // εμφανιζόταν ως «Ελέγξτε τα στοιχεία που συμπληρώσατε», δηλαδή έστελνε τον
    // χρήστη να διορθώσει πεδία που δεν έφταιγαν. Το γενικό μήνυμα δεν είναι
    // ουδέτερη εφεδρεία — **κουβαλά υπόθεση για την αιτία**.
    'The last administrator cannot be demoted; promote another administrator first':
        'Δεν μπορείτε να υποβιβάσετε τον τελευταίο διαχειριστή. Ορίστε πρώτα κάποιον άλλον.',
    // Η ίδια κατηγορία: επιχειρησιακός κανόνας, όχι σφάλμα πεδίου.
    'Assignees must be members of this collection':
        'Ανάδοχος μπορεί να είναι μόνο μέλος αυτής της συλλογής.',
    // D44: η ίδια κατηγορία με το παραπάνω — επιχειρησιακός κανόνας πάνω σε
    // καλοσχηματισμένο αίτημα, όχι σφάλμα πεδίου. Το **γενικό** μήνυμα του
    // κωδικού («Ελέγξτε τα στοιχεία που συμπληρώσατε») θα έστελνε τον χρήστη να
    // ψάξει τι έγραψε λάθος στη φόρμα, ενώ αυτό που φταίει είναι ένα όνομα μέσα
    // στο κείμενο. Η οθόνη το **αντικαθιστά** με πρόταση που ονομάζει ποια
    // ονόματα (`MENTIONS.notMembers`)· εδώ ζει η εφεδρεία, που είναι πάντοτε
    // ελληνική και πάντοτε **μία** για τις δύο αποτυχίες.
    'Mentioned users must be members of this collection':
        'Οι αναφορές πρέπει να αντιστοιχούν σε μέλη αυτής της συλλογής.',

    // ── Τα εννέα που βρήκε ο φράχτης των μηνυμάτων, με την πρώτη του εκτέλεση ──
    //
    // Η πρώτη σάρωση —με το χέρι, και μόνο στους κωδικούς 400 και 422— είχε βρει
    // **τέσσερα**. Ο φράχτης, που διαβάζει **κάθε** κωδικό, βρήκε **εννέα
    // ακόμη**. Η διαφορά δεν είναι επιμέλεια: η σάρωση με το χέρι έψαξε εκεί
    // όπου είχε ήδη εμφανιστεί το σφάλμα, δηλαδή απάντησε στο ερώτημα «υπάρχει
    // κι άλλο **σαν αυτό**;» αντί για «υπάρχει κι άλλο;».
    'Only the assignees of this task may update its progress':
        'Την πρόοδο ενός καθηκόντος την ενημερώνει ο ανάδοχός του ή ο συντονιστής.',
    'Revoke the API key before deleting it':
        'Ανακαλέστε πρώτα το κλειδί. Η οριστική διαγραφή είναι δεύτερο, ρητό βήμα.',
    'API key not found': 'Το κλειδί δεν βρέθηκε. Ίσως διαγράφηκε από άλλον διαχειριστή.',
    'Task not found': 'Το καθήκον δεν βρέθηκε. Ίσως διαγράφηκε.',
    'Notification not found': 'Η ειδοποίηση δεν βρέθηκε.',
    'Webhook subscription not found': 'Η συνδρομή δεν βρέθηκε. Ίσως διαγράφηκε.',
    'Webhook delivery not found': 'Η καταγραφή παράδοσης δεν βρέθηκε.',

    // Συλλογές
    'Collection not found': 'Η συλλογή δεν βρέθηκε.',
    'A resource cannot be related to itself': 'Ο πόρος δεν συσχετίζεται με τον εαυτό του.',
    'Invalid collection identifier': 'Το αναγνωριστικό της συλλογής δεν είναι έγκυρο.',
    'Collection is archived and cannot be modified':
        'Η συλλογή είναι αρχειοθετημένη και δεν δέχεται αλλαγές. Επαναφέρετέ την πρώτα.',
    'A collection must keep at least one coordinator':
        'Η συλλογή πρέπει να διατηρεί τουλάχιστον έναν συντονιστή.',

    // Μέλη
    'User not found': 'Δεν βρέθηκε χρήστης με αυτό το όνομα.',
    'User is already a member of this collection': 'Ο χρήστης είναι ήδη μέλος της συλλογής.',
    'Membership not found': 'Η συμμετοχή δεν βρέθηκε.',

    // Πόροι
    'Resource not found': 'Ο πόρος δεν βρέθηκε.',
    'Resource not found in this collection': 'Ο πόρος δεν βρέθηκε σε αυτή τη συλλογή.',
    'This URL is already registered in this collection':
        'Η διεύθυνση υπάρχει ήδη σε αυτή τη συλλογή.',

    // Άντληση μεταδεδομένων (Απόφαση D12). Το μήνυμα της αποκλεισμένης
    // διεύθυνσης είναι σκόπιμα **ένα**, όπως και στο API: αν η διεπαφή
    // ξεχώριζε το «ιδιωτικό δίκτυο» από το «δεν βρέθηκε», θα ανακοίνωνε την
    // τοπολογία που ο εξυπηρετητής φρόντισε να μην πει.
    'This address cannot be reached from the server':
        'Η διεύθυνση δεν είναι προσβάσιμη. Ελέγξτε την ή συμπληρώστε τα στοιχεία με το χέρι.',
    'Only http and https addresses can be fetched':
        'Η άντληση γίνεται μόνο για διευθύνσεις http και https.',
    'Addresses with embedded credentials are not accepted':
        'Η διεύθυνση δεν πρέπει να περιέχει όνομα χρήστη και κωδικό.',
    'The page took too long to respond':
        'Η σελίδα άργησε να απαντήσει. Συμπληρώστε τα στοιχεία με το χέρι.',
    'The page responded with an error':
        'Η σελίδα απάντησε με σφάλμα. Ελέγξτε τη διεύθυνση.',
    'The page could not be read':
        'Η σελίδα δεν διαβάστηκε. Συμπληρώστε τα στοιχεία με το χέρι.',
    'Too many metadata requests, please slow down':
        'Πολλές διαδοχικές αντλήσεις. Περιμένετε λίγο πριν ξαναδοκιμάσετε.',

    // Γενικά
    'Validation failed': 'Ελέγξτε τα στοιχεία που συμπληρώσατε.',
    'Malformed JSON body': 'Το αίτημα δεν είναι έγκυρο.',
    'This feature is not available yet': 'Η λειτουργία δεν είναι διαθέσιμη ακόμη.',
    'Missing X-API-Key header': 'Λείπει το κλειδί API.',
    'Invalid or revoked API key': 'Το κλειδί API δεν είναι έγκυρο ή έχει ανακληθεί.',

    // feat/topics — D47. Το «Unknown topic» φτάνει στη φόρμα της συλλογής με
    // `field: 'topic'`, οπότε εμφανίζεται **δίπλα στον επιλογέα**· η γενική
    // διατύπωση του κωδικού θα το έστελνε στην κορυφή της φόρμας, όπου ο χρήστης
    // δεν θα καταλάβαινε ποιο πεδίο φταίει (ΜΛΑ-03).
    'Unknown topic':
        'Το θεματικό αντικείμενο δεν υπάρχει στο λεξιλόγιο. Διαλέξτε ένα από τη λίστα.',
    'Topic not found': 'Το θεματικό αντικείμενο δεν βρέθηκε.'
};

/**
 * Μηνύματα επικύρωσης ανά πεδίο, από το `details[]` του 422.
 *
 * Το zod παράγει αγγλικά μηνύματα τύπου «String must contain at least 8
 * character(s)». Μεταφράζονται με βάση το **πεδίο** και όχι το κείμενο, γιατί το
 * κείμενο του zod αλλάζει μεταξύ εκδόσεων.
 */
const BY_FIELD = {
    username: 'Το όνομα χρήστη πρέπει να έχει 3 έως 32 χαρακτήρες: λατινικά γράμματα, ψηφία, τελεία, παύλα ή κάτω παύλα.',
    email: 'Δώστε έγκυρη διεύθυνση ηλεκτρονικού ταχυδρομείου.',
    password: 'Ο κωδικός πρέπει να έχει τουλάχιστον 8 χαρακτήρες.',
    fullName: 'Το ονοματεπώνυμο πρέπει να έχει τουλάχιστον 2 χαρακτήρες.',
    title: 'Ο τίτλος πρέπει να έχει τουλάχιστον 2 χαρακτήρες.',
    url: 'Δώστε πλήρη διεύθυνση, μαζί με το https://.',
    image: 'Δώστε πλήρη διεύθυνση εικόνας, μαζί με το https://.',
    avatar: 'Δώστε πλήρη διεύθυνση εικόνας, μαζί με το https://.',
    topic: 'Το θεματικό αντικείμενο δεν πρέπει να ξεπερνά τους 120 χαρακτήρες.',
    description: 'Η περιγραφή δεν πρέπει να ξεπερνά τους 2000 χαρακτήρες.',
    tags: 'Κάθε ετικέτα έχει έως 60 χαρακτήρες, και το πλήθος έως 30.',
    interests: 'Κάθε ενδιαφέρον έχει έως 60 χαρακτήρες, και το πλήθος έως 30.'
};

/** Το ελληνικό μήνυμα ενός σφάλματος του API. Ποτέ δεν επιστρέφει αγγλικά. */
export function messageOf(error) {
    if (!error) return BY_CODE.UNKNOWN_ERROR;

    return BY_MESSAGE[error.message] ?? BY_CODE[error.code] ?? BY_CODE.UNKNOWN_ERROR;
}

/**
 * D44: το ίδιο, με **τα ονόματα** όταν η άρνηση αφορά αναφορές.
 *
 * ⚠ **Γιατί δεν αρκεί το `messageOf`.** Εκείνο μεταφράζει τον **τύπο** της
 * άρνησης, και η μετάφραση είναι σωστή: «οι αναφορές πρέπει να αντιστοιχούν σε
 * μέλη». Ο χρήστης όμως έχει γράψει ένα κείμενο με τρεις αναφορές και δεν ξέρει
 * **ποια** φταίει — και η μόνη ενέργεια που του απομένει είναι να τις σβήσει και
 * τις τρεις. Ο διακομιστής **στέλνει ήδη** τα ονόματα στις λεπτομέρειες· αυτό που
 * έλειπε ήταν να τα διαβάσει κάποιος.
 *
 * **Ονομάζει ποια, ποτέ γιατί.** Η διάκριση «άγνωστο όνομα» και «υπαρκτός μη
 * μέλος» δεν φτάνει ποτέ στην οθόνη, γιατί δεν φτάνει ούτε στην απόκριση: το
 * μήνυμα είναι **ένα** και για τις δύο αποτυχίες, ώστε η φόρμα σχολίου να μη
 * γίνει εργαλείο απαρίθμησης λογαριασμών.
 *
 * **Μία διατύπωση για τα τρία πεδία συνομιλίας.** Σχόλιο, αιτιολόγηση εκτίμησης
 * και σημείωση προόδου καλούν αυτή τη συνάρτηση· τρεις αντιγραμμένες συνθήκες θα
 * απέκλιναν στην πρώτη αλλαγή που θα θυμόταν μόνο τη μία.
 */
export function mentionMessageOf(error) {
    const names = error?.details?.usernames;
    if (Array.isArray(names) && names.length > 0) return MENTIONS.notMembers(names);

    return messageOf(error);
}

/**
 * Μηνύματα ανά **τύπο** ζητήματος, όταν το όνομα του πεδίου δεν αρκεί.
 *
 * Η ανάγκη προέκυψε από συγκεκριμένο ελάττωμα (εύρημα 2θ). Η υπέρβαση μήκους
 * διεύθυνσης εμφανιζόταν ως «Δώστε πλήρη διεύθυνση, μαζί με το https://», δηλαδή
 * το μήνυμα του πεδίου `url` — και έλεγε στον χρήστη να **συμπληρώσει** κάτι που
 * είχε ήδη συμπληρώσει σωστά. Η διεύθυνση δεν ήταν ελλιπής, ήταν πολύ μεγάλη.
 *
 * Είναι ακριβώς η περίπτωση που απαγορεύει η **ΜΛΑ-03**: μήνυμα σφάλματος που
 * δεν καθοδηγεί στη διόρθωση αλλά προς λάθος κατεύθυνση. Το API στέλνει πλέον τον
 * κωδικό του zod στο `details[].code`, και η μετάφραση τον προτιμά όπου υπάρχει.
 */
const BY_ISSUE = {
    url: {
        too_big: 'Η διεύθυνση είναι πολύ μεγάλη. Το όριο είναι 4096 χαρακτήρες, και οι ελληνικοί χαρακτήρες μετρούν ως έξι ο καθένας.',
        // Απόφαση D10: το API απορρίπτει το `url` στο σχήμα ενημέρωσης. Το μήνυμα
        // δεν λέει «μη έγκυρη τιμή» αλλά **γιατί** δεν αλλάζει και τι να κάνει ο
        // χρήστης αντ' αυτού.
        unrecognized_keys: 'Η διεύθυνση δεν αλλάζει μετά την καταχώρηση: είναι η ταυτότητα του πόρου. Χρησιμοποιήστε την «Αποσύνδεση και νέα καταχώρηση».'
    },
    image: {
        too_big: 'Η διεύθυνση της εικόνας είναι πολύ μεγάλη.'
    },
    title: {
        too_big: 'Ο τίτλος δεν πρέπει να ξεπερνά τους 300 χαρακτήρες.'
    },
    description: {
        too_big: 'Η περιγραφή δεν πρέπει να ξεπερνά τους 2000 χαρακτήρες.'
    }
};

/**
 * Το ελληνικό μήνυμα για ένα πεδίο που απέρριψε το API.
 *
 * Ο `code` είναι ο τύπος του ζητήματος κατά το zod (`too_big`, `invalid_string`,
 * `too_small`). Είναι προαιρετικός: παλιότερες αποκρίσεις δεν τον φέρουν, και
 * τότε ισχύει το μήνυμα του πεδίου.
 */
export function fieldMessageOf(field, code) {
    return BY_ISSUE[field]?.[code] ?? BY_FIELD[field] ?? 'Η τιμή δεν είναι έγκυρη.';
}

/**
 * Σχετικός χρόνος στα ελληνικά, με το ενσωματωμένο `Intl.RelativeTimeFormat`.
 *
 * Αντικατέστησε το `moment`, που ήταν η **τελευταία** εξάρτηση χρόνου:
 * παρήγαγε «2 hours ago» και η μετάφρασή του απαιτεί φόρτωση αρχείου locale. Το
 * `Intl` είναι μέρος του περιηγητή, γνωρίζει ήδη τους ελληνικούς τύπους, και με
 * `numeric: 'auto'` δίνει «χθες» αντί για «πριν από 1 ημέρα» όπου η γλώσσα το
 * προτιμά.
 *
 * Η μονάδα επιλέγεται από τη μεγαλύτερη που χωράει, ώστε να μη γράφεται «πριν από
 * 3600 δευτερόλεπτα».
 */
const FORMATTER = new Intl.RelativeTimeFormat('el', { numeric: 'auto' });

const UNITS = [
    ['year', 365 * 24 * 60 * 60 * 1000],
    ['month', 30 * 24 * 60 * 60 * 1000],
    ['week', 7 * 24 * 60 * 60 * 1000],
    ['day', 24 * 60 * 60 * 1000],
    ['hour', 60 * 60 * 1000],
    ['minute', 60 * 1000]
];

export function relativeTime(date, now = Date.now()) {
    const value = date instanceof Date ? date : new Date(date);
    if (!date || Number.isNaN(value.getTime())) return '';

    const elapsed = value.getTime() - now;
    const magnitude = Math.abs(elapsed);

    // Κάτω από ένα λεπτό δεν χρησιμοποιείται μονάδα: το «πριν από 12
    // δευτερόλεπτα» ανανεώνεται ταχύτερα από όσο διαβάζεται.
    if (magnitude < 60 * 1000) return 'μόλις τώρα';

    for (const [unit, size] of UNITS) {
        if (magnitude >= size) {
            return FORMATTER.format(Math.round(elapsed / size), unit);
        }
    }

    return 'μόλις τώρα';
}

/**
 * Σχόλια και αξιολογήσεις (P1-3, ΛΑ-16 και ΛΑ-17).
 *
 * Νέο μπλοκ **στο τέλος** και όχι νέα κλειδιά μέσα στα υπάρχοντα: τρεις κλάδοι
 * γράφουν παράλληλα, και δύο προσθήκες σε διαφορετικά σημεία συγχωνεύονται καθαρά
 * ενώ δύο επεξεργασίες της ίδιας γραμμής ποτέ. Για τον ίδιο λόγο δεν ενημερώνεται
 * το `export default` του αρχείου: η ενημέρωσή του είναι **επεξεργασία** και ανήκει
 * στο P1-5. Τα συστατικά εισάγουν το ονομαστικό `JUDGEMENTS`.
 */
export const JUDGEMENTS = {
    comments: 'Σχόλια',
    ratings: 'Αξιολογήσεις',
    // Ο συλλογικός όρος είναι **η απαρίθμηση των δύο**, όχι μια λέξη που τα
    // σκεπάζει. Ήταν «Κρίσεις», δανεισμένο από τη γραμμή του μοντέλου — «κοινά τα
    // δεδομένα, ιδιωτικές οι κρίσεις». Η γραμμή είναι σωστή ως **σκεπτικό
    // σχεδίασης** και λάθος ως **ετικέτα οθόνης**: τα Κεφάλαια 3 και 4 δεν
    // χρησιμοποιούν πουθενά τη λέξη προς τον χρήστη, ονομάζουν σχόλια (ΛΑ-16) και
    // αξιολογήσεις (ΛΑ-17), και ο χρήστης δεν έχει από πού να μάθει τι σημαίνει.
    // Ορολογία που υπάρχει μόνο στο μυαλό του σχεδιαστή δεν είναι ορολογία.
    judgements: 'Σχόλια και αξιολογήσεις',

    commentPlaceholder: 'Γράψτε ένα σχόλιο για αυτόν τον πόρο…',
    submitComment: 'Υποβολή σχολίου',
    noComments: 'Κανένα σχόλιο σε αυτή τη συλλογή ακόμη.',
    noRatings: 'Καμία αξιολόγηση σε αυτή τη συλλογή ακόμη.',

    relevanceLabel: 'Εκτίμηση συνάφειας',
    // Η κλίμακα **δεν ορίζεται στα Κεφάλαια 3 και 4**: είναι απόφαση της
    // υλοποίησης, τεκμηριωμένη στο docs/notes/p1-3.md.
    relevance: {
        high: 'Υψηλή συνάφεια',
        medium: 'Μεσαία συνάφεια',
        low: 'Χαμηλή συνάφεια'
    },
    justificationLabel: 'Αιτιολόγηση',
    justificationHint: 'Προαιρετική, αλλά είναι αυτή που έχει αξία για την ομάδα.',
    submitRating: 'Καταγραφή εκτίμησης',
    updateRating: 'Ενημέρωση εκτίμησης',
    myRating: 'Η εκτίμησή σας',
    ratingSaved: 'Η εκτίμησή σας καταγράφηκε.',
    ratingUpdated: 'Η εκτίμησή σας ενημερώθηκε.',

    // Η ορατότητα δηλώνεται ρητά: ο χρήστης πρέπει να ξέρει ότι γράφει **μέσα σε
    // μια ομάδα** και όχι δημόσια πάνω στον πόρο, γιατί ο πόρος είναι κοινός (D9).
    scopeNote: 'Τα σχόλια και οι αξιολογήσεις αφορούν αυτή τη συλλογή και δεν φαίνονται στις υπόλοιπες συλλογές του πόρου.',
    readOnlyNote: 'Δεν είστε μέλος αυτής της συλλογής, οπότε μπορείτε μόνο να διαβάσετε.',

    // Η εκτίμηση **κλειδώνει** μετά την υποβολή: η φόρμα που έμενε ανοιχτή δεν
    // έδειχνε αν καταχωρήθηκε τίποτα, και ο χρήστης δεν είχε τρόπο να ξεχωρίσει
    // «γράφω» από «έγραψα».
    recorded: 'Η εκτίμησή σας καταγράφηκε',
    editRating: 'Επεξεργασία',
    cancelRating: 'Ακύρωση',
    noJustification: 'Χωρίς αιτιολόγηση.',

    // Τίτλοι αποτυχίας. Υπάρχουν ώστε το μήνυμα του διακομιστή να μπαίνει ως
    // **περιγραφή** κάτω από τίτλο που λέει τι απέτυχε: «Υπάρχει ήδη» σκέτο, χωρίς
    // τίτλο, δεν λέει σε ποια ενέργεια αναφέρεται.
    commentFailed: 'Το σχόλιο δεν καταχωρήθηκε',
    ratingFailed: 'Η εκτίμηση δεν καταγράφηκε',

    // ΠΡΟΣΟΧΗ: το πλήθος μετριέται ΑΥΣΤΗΡΑ μέσα στην τρέχουσα συλλογή (D13, D14).
    // Ένδειξη που μετρούσε όλες τις συλλογές του πόρου θα διέρρεε τη δραστηριότητα
    // ιδιωτικής ομάδας, ακριβώς όπως θα το έκανε ένα αφιλτράριστο `collections[]`.
    othersRated: (count) =>
        count === 1
            ? 'Ένα ακόμη μέλος αυτής της συλλογής έχει καταγράψει εκτίμηση.'
            : `${count} ακόμη μέλη αυτής της συλλογής έχουν καταγράψει εκτίμηση.`,
    onlyYouRated: 'Είστε το μόνο μέλος αυτής της συλλογής που έχει καταγράψει εκτίμηση.',

    // Οι καρτέλες του παραθύρου. Τρεις σε στενή οθόνη, όπου υπάρχει μία στήλη·
    // οι δύο τελευταίες μόνο, πάνω από τη δεξιά στήλη, όταν η οθόνη τις χωρά
    // δίπλα-δίπλα. Τα σχόλια και οι αξιολογήσεις ήταν δύο στοίβες η μία κάτω από
    // την άλλη: με πολλά και από τα δύο, το ένα έσπρωχνε το άλλο εκτός οθόνης.
    tabResource: 'Ο πόρος',
    tabRatings: 'Αξιολογήσεις',
    tabComments: 'Σχόλια',

    summaryTitle: 'Σχόλια και αξιολογήσεις της συλλογής',
    summaryEmpty: 'Κανένα σχόλιο και καμία αξιολόγηση σε αυτή τη συλλογή ακόμη.',
    summaryResources: 'Πόροι με σχόλια ή αξιολογήσεις',
    summaryTopRatings: 'Οι πιο αξιολογημένοι πόροι',
    summaryTopComments: 'Οι πιο σχολιασμένοι πόροι'
};

/** «1 σχόλιο» / «4 σχόλια», με τη σωστή μορφή και στα δύο. */
function plural(count, one, many) {
    return `${count} ${count === 1 ? one : many}`;
}

/**
 * Η προειδοποίηση της **Απόφασης D13**, πριν από την αποσύνδεση πόρου.
 *
 * Η ΜΛΑ-03 απαιτεί προειδοποίηση πριν από μη αναστρέψιμη ενέργεια, και εδώ το
 * κόστος δεν είναι προφανές: ο χρήστης νομίζει ότι αφαιρεί έναν σύνδεσμο, ενώ
 * διαγράφει **και τις κρίσεις της ομάδας του** — δικές του και άλλων. Χωρίς το
 * πλήθος, η επιβεβαίωση δεν λέει τι κοστίζει.
 */
export function detachWarning({ commentCount = 0, ratingCount = 0 } = {}) {
    const parts = [];
    if (commentCount > 0) parts.push(plural(commentCount, 'σχόλιο', 'σχόλια'));
    if (ratingCount > 0) parts.push(plural(ratingCount, 'αξιολόγηση', 'αξιολογήσεις'));

    if (parts.length === 0) return '';
    return `Θα διαγραφούν επίσης ${parts.join(' και ')} αυτής της συλλογής. Η ενέργεια δεν αναιρείται.`;
}

// ── P1-5: αναζήτηση, ταξινόμηση και άντληση μεταδεδομένων ──────────────────────
//
// Νέο μπλοκ στο τέλος, κατά τον κανόνα των αρχείων μόνο-προσθήκης: τρεις κλάδοι
// που γράφουν στο ίδιο σημείο του `LABELS` παράγουν σύγκρουση σε κάθε merge, ενώ
// τρεις προσθήκες στο τέλος συγχωνεύονται καθαρά.

/**
 * Η **προέλευση** κάθε αντλημένου πεδίου (ΛΑ-09).
 *
 * Δεν είναι διακοσμητικό: είναι το ορατό τεκμήριο της απαίτησης. Ο χρήστης
 * βλέπει τι **διάβασε** το σύστημα από τη σελίδα και τι **μάντεψε**, οπότε ξέρει
 * ποιο πεδίο αξίζει να ελέγξει πριν καταχωρήσει. Οι ίδιες τρεις ενδείξεις
 * εμφανίζονται και στην επέκταση, με τα ίδια λόγια.
 */
export const METADATA_SOURCES = {
    ogp: 'Open Graph',
    page: 'Σελίδα',
    fallback: 'Εικασία'
};

/** Οι επιλογές ταξινόμησης, με τη σειρά που εμφανίζονται (ΛΑ-06, ΛΑ-15). */
export const SORT_OPTIONS = {
    resources: [
        { id: 'createdAt:desc', label: 'Νεότερα πρώτα' },
        { id: 'createdAt:asc', label: 'Παλαιότερα πρώτα' },
        { id: 'updatedAt:desc', label: 'Πρόσφατη μεταβολή' },
        { id: 'title:asc', label: 'Τίτλος, Α→Ω' },
        { id: 'title:desc', label: 'Τίτλος, Ω→Α' }
    ],
    collections: [
        { id: 'updatedAt:desc', label: 'Πρόσφατη μεταβολή' },
        { id: 'createdAt:desc', label: 'Νεότερες πρώτα' },
        { id: 'createdAt:asc', label: 'Παλαιότερες πρώτα' },
        { id: 'title:asc', label: 'Τίτλος, Α→Ω' },
        { id: 'title:desc', label: 'Τίτλος, Ω→Α' }
    ]
};

/** Κείμενα της άντλησης μεταδεδομένων και του μόνιμου συνδέσμου. */
export const P1_5_TEXT = {
    fetchMetadata: 'Άντληση στοιχείων',
    fetchingMetadata: 'Γίνεται άντληση…',
    metadataFilled: 'Τα στοιχεία συμπληρώθηκαν από τη σελίδα. Ελέγξτε τα πριν την καταχώρηση.',
    metadataNeedsUrl: 'Συμπληρώστε πρώτα τη διεύθυνση.',
    // Η άντληση ακολουθεί ανακατευθύνσεις, οπότε η διεύθυνση που θα αποθηκευτεί
    // μπορεί να διαφέρει από αυτήν που επικόλλησε ο χρήστης. Δεν αλλάζει σιωπηλά
    // κάτω από τα μάτια του (ΜΛΑ-03).
    metadataRedirected: 'Η διεύθυνση οδήγησε αλλού και ενημερώθηκε.',
    // Σκέλος β του μόνιμου συνδέσμου: άγνωστο ή ξένο αναγνωριστικό δίνει
    // **κανονική σελίδα** με διακριτική ειδοποίηση, ποτέ κενή οθόνη ή σφάλμα.
    // Το ίδιο μήνυμα και για τον πόρο που δεν υπάρχει και για εκείνον που δεν
    // ανήκει εδώ: η διάκριση θα ήταν συναγωγή ύπαρξης.
    resourceLinkMissing: 'Ο πόρος του συνδέσμου δεν βρέθηκε σε αυτή τη συλλογή. Ίσως αφαιρέθηκε.',
    // Απόφαση Α8α: η κάρτα του συνδέσμου εμφανίζεται εκτός σειράς ταξινόμησης και το
    // **δηλώνει**, αντί να αφήσει τον χρήστη να το εκλάβει ως σφάλμα.
    pinnedByLink: 'Εμφανίζεται εδώ επειδή τον ζητά ο σύνδεσμος — βρίσκεται σε άλλη σελίδα.',
    // Οι τρεις προβολές του καταλόγου συλλογών. Η «Δημόσιες» είναι η ανακάλυψη
    // που έλειπε: το δικαίωμα ανάγνωσης δημόσιας συλλογής υπήρχε και ασκούνταν
    // μόνο από κοινοποιημένο σύνδεσμο.
    viewEmpty: {
        mine: 'Δεν έχετε συλλογές ακόμη. Δημιουργήστε την πρώτη σας.',
        archived: 'Δεν υπάρχουν αρχειοθετημένες συλλογές.',
        public: 'Καμία δημόσια συλλογή ακόμη. Οι δημόσιες συλλογές είναι ορατές σε όλους.'
    },
    copyLink: 'Αντιγραφή συνδέσμου',
    linkCopied: 'Ο σύνδεσμος αντιγράφηκε.',

    // ── ΣΕΤ Β: η γραμμή φίλτρων και τα ενεργά φίλτρα (Απόφαση D30) ───────────
    //
    // Νέο μπλοκ στο τέλος της οικείας ενότητας.
    filtersToggle: 'Φίλτρα',
    filtersHide: 'Απόκρυψη φίλτρων',
    sortLabel: 'Ταξινόμηση',
    // Ο τίτλος του πλαισίου της περιγραφής συλλογής. Ονομάζει **τι είναι** το
    // κείμενο: ένα κουτί δίπλα στο όνομα μιας συλλογής μπορεί εξίσου να είναι
    // ανακοίνωση ή προειδοποίηση.
    collectionDescription: 'Περιγραφή συλλογής',
    // Τα ενεργά φίλτρα μένουν ορατά **έξω** από τη συμπτυσσόμενη περιοχή: η
    // σύμπτυξη δεν επιτρέπεται να κρύψει τον λόγο για τον οποίο το αποτέλεσμα
    // είναι μικρό (ΜΛΑ-03).
    filterActive: 'Ενεργά φίλτρα:',
    filterRemove: 'Αφαίρεση του φίλτρου',
    filterClear: 'Καθαρισμός',
    filterTag: 'Ετικέτα',
    filterCreatedBy: 'Συντάκτης',
    filterFrom: 'Από',
    filterTo: 'Έως',

    // ── ΣΕΤ Β: οι καρτέλες της σελίδας συλλογής (Απόφαση D27) ────────────────
    tabs: {
        resources: 'Πόροι',
        tasks: 'Καθήκοντα',
        judgements: 'Σχόλια και αξιολογήσεις',
        activity: 'Δραστηριότητα',
        members: 'Μέλη'
    },
    tabsLabel: 'Καρτέλες συλλογής'
};

// Το **ένα** `export default` του αρχείου, στο τέλος. Και οι δύο κλάδοι πρόσθεσαν
// μπλοκ κατά τον κανόνα των αρχείων μόνο-προσθήκης, οπότε η μόνη πραγματική
// σύγκρουση ήταν εδώ: το P1-3 άφησε ρητά την ενημέρωσή του στο P1-5, γιατί είναι
// **επεξεργασία** και όχι προσθήκη. Τα `JUDGEMENTS` και `detachWarning` μπαίνουν
// τώρα, στην ενσωμάτωση, όπου ανήκε η απόφαση.
export default {
    APP,
    LABELS,
    RESOURCE_CREATED,
    METADATA_SOURCES,
    SORT_OPTIONS,
    P1_5_TEXT,
    JUDGEMENTS,
    messageOf,
    fieldMessageOf,
    relativeTime,
    detachWarning
};

/**
 * Κλειδιά πρόσβασης API (P1-8, ΜΛΑ-08).
 *
 * Νέο μπλοκ στο τέλος, κατά τον κανόνα των αρχείων μόνο-προσθήκης. Το
 * `export default` δεν ενημερώνεται: η ενημέρωσή του είναι επεξεργασία και ανήκει
 * στον κλάδο που κατέχει το αρχείο. Τα συστατικά εισάγουν το ονομαστικό `API_KEYS`.
 */
export const API_KEYS = {
    title: 'Κλειδιά πρόσβασης',
    intro: 'Τα κλειδιά επιτρέπουν σε εξωτερικές εφαρμογές να διαβάζουν δεδομένα μέσω του API. Κάθε κλειδί ισχύει για μία μόνο συλλογή.',

    label: 'Περιγραφικός τίτλος',
    labelHint: 'Ποια εφαρμογή το χρησιμοποιεί — π.χ. «Πρόσθετο WordPress».',
    collection: 'Συλλογή',
    collectionHint: 'Το κλειδί θα διαβάζει μόνο αυτή τη συλλογή.',
    create: 'Δημιουργία κλειδιού',
    creating: 'Δημιουργία…',

    // Το κείμενο που κάνει τη μοναδική εμφάνιση κατανοητή **πριν** ο χρήστης
    // κλείσει την οθόνη. Η προειδοποίηση δεν είναι διακοσμητική: το μυστικό δεν
    // υπάρχει πουθενά στον εξυπηρετητή μετά από αυτή τη στιγμή.
    secretTitle: 'Αντιγράψτε το τώρα — δεν θα ξαναεμφανιστεί',
    secretWarning: 'Το κλειδί αποθηκεύεται μόνο ως κρυπτογραφικό αποτύπωμα. Αν χαθεί, δεν ανακτάται: ανακαλέστε το και δημιουργήστε νέο.',
    copy: 'Αντιγραφή',
    copied: 'Αντιγράφηκε',

    listTitle: 'Ενεργά και ανακλημένα κλειδιά',
    empty: 'Δεν υπάρχει κανένα κλειδί ακόμη.',
    createdAt: 'Δημιουργήθηκε',
    lastUsedAt: 'Τελευταία χρήση',
    neverUsed: 'Δεν έχει χρησιμοποιηθεί',
    active: 'Ενεργό',
    revoked: 'Ανακλημένο',

    revoke: 'Ανάκληση',
    revokeTitle: 'Ανάκληση κλειδιού',
    revokeWarning: 'Η εφαρμογή που το χρησιμοποιεί θα σταματήσει να έχει πρόσβαση αμέσως. Η ενέργεια δεν αναιρείται — για επαναφορά πρόσβασης δημιουργείται νέο κλειδί.',
    revokeConfirm: 'Ανάκληση',
    cancel: 'Ακύρωση',

    keysNoun: 'κλειδιά',

    // Οι καρτέλες. **Πληθυντικός, και δεν είναι το ίδιο κλειδί με τα `active`/
    // `revoked`**: εκείνα είναι η ένδειξη ΕΝΟΣ κλειδιού («Ενεργό») και μπαίνουν σε
    // σήμα δίπλα στο όνομά του· αυτά ονομάζουν ΣΥΝΟΛΟ («Ενεργά»). Η επαναχρησιμοποίηση
    // του ενικού στην καρτέλα θα διάβαζε «Ενεργό (3)».
    viewLabel: 'Προβολή κλειδιών',
    viewActive: 'Ενεργά',
    viewRevoked: 'Ανακλημένα',

    // Κενή καρτέλα ≠ κενός κατάλογος. Το `empty` λέει «δεν υπάρχει κανένα κλειδί»
    // και θα ήταν ψευδές σε οθόνη που δείχνει τρία ανακλημένα.
    emptyActive: 'Κανένα ενεργό κλειδί. Όσα εκδόθηκαν έχουν ανακληθεί.',
    emptyRevoked: 'Κανένα ανακλημένο κλειδί.',

    // D24: η διαγραφή ανακλημένου. Η προειδοποίηση **ονομάζει τι χάνεται** και δεν
    // λέει απλώς «δεν αναιρείται»: το ιστορικό χρήσης είναι ένα πεδίο πάνω στο
    // έγγραφο, και η διαγραφή το σβήνει από τη βάση οριστικά.
    delete: 'Διαγραφή',
    deleteTitle: 'Οριστική διαγραφή κλειδιού',
    deleteConfirm: 'Διαγραφή',
    deleteWarning: 'Το κλειδί φεύγει από τον κατάλογο οριστικά. Η ανάκληση έχει ήδη σταματήσει την πρόσβαση — η διαγραφή αφαιρεί το τεκμήριο.',
    deleteLoses: 'Χάνεται η ένδειξη τελευταίας χρήσης:',
    deleteLosesNothing: 'Το κλειδί δεν χρησιμοποιήθηκε ποτέ — δεν χάνεται ένδειξη χρήσης.'
};

// ── P2-3: δομημένα στοιχεία χρηματοδότησης και φίλτρα μελέτης περίπτωσης ─────
export const FUNDING = {
    section: 'Στοιχεία χρηματοδοτικής ευκαιρίας',
    optionalHelp: 'Όλα τα πεδία είναι προαιρετικά και κοινά σε όσες συλλογές περιέχουν τον πόρο.',
    agency: 'Φορέας χρηματοδότησης',
    agencyPlaceholder: 'π.χ. ΕΛΙΔΕΚ, Ευρωπαϊκή Επιτροπή',
    field: 'Επιστημονικό πεδίο',
    fieldPlaceholder: 'π.χ. Βιοϊατρική, Ενέργεια',
    deadline: 'Προθεσμία υποβολής',
    amount: 'Μέγιστη χρηματοδότηση (€)',
    amountPlaceholder: 'π.χ. 50.000,50',
    amountUnreadable: 'Το ποσό δεν διαβάζεται. Γράψτε το ως «50.000,50» ή «50000.50», με ψηφία και ένα δεκαδικό διαχωριστικό.',
    eligibleEntities: 'Επιλέξιμοι φορείς',
    terms: 'Βασικοί όροι συμμετοχής',
    rollingDeadlineHelp: 'Για «έως τη λήξη των πιστώσεων», αφήστε την ημερομηνία κενή και γράψτε εδώ την ακριβή διατύπωση.',
    filters: 'Φίλτρα χρηματοδότησης',
    deadlineBefore: 'Προθεσμία έως',
    minAmount: 'Ελάχιστη χρηματοδότηση (€)',
    eligible: 'Επιλέξιμος φορέας',
    relevance: 'Καταγεγραμμένη συνάφεια',
    allRelevance: 'Οποιαδήποτε συνάφεια',
    expired: 'Ληγμένη',
    noCalendarDeadline: 'Χωρίς ημερολογιακή προθεσμία'
};

/**
 * Καθήκοντα (P1-4, ΛΑ-18 έως ΛΑ-20).
 *
 * Νέο μπλοκ **στο τέλος** και όχι νέα κλειδιά μέσα στα υπάρχοντα, κατά τον κανόνα
 * των αρχείων μόνο-προσθήκης. Για τον ίδιο λόγο δεν ενημερώνεται το
 * `export default`: η ενημέρωσή του είναι **επεξεργασία** και ανήκει στο P1-5. Τα
 * συστατικά εισάγουν το ονομαστικό `TASKS`.
 *
 * **Οι τρεις καταστάσεις είναι το κείμενο της ΛΑ-19, αυτούσιο**: «προς εκτέλεση»,
 * «σε εξέλιξη», «ολοκληρωμένο». Δεν είναι επιλογή διατύπωσης — είναι η ορολογία
 * της απαίτησης, και η οθόνη δεν εφευρίσκει δεύτερη.
 */
export const TASKS = {
    title: 'Καθήκοντα',
    empty: 'Κανένα καθήκον σε αυτή τη συλλογή ακόμη.',
    emptyManage: 'Κανένα καθήκον ακόμη. Ο συντονιστής μπορεί να δημιουργήσει το πρώτο.',

    status: {
        todo: 'Προς εκτέλεση',
        in_progress: 'Σε εξέλιξη',
        done: 'Ολοκληρωμένο'
    },
    statusLabel: 'Κατάσταση',

    create: 'Νέο καθήκον',
    createTitle: 'Νέο καθήκον',
    editTitle: 'Επεξεργασία καθηκόντος',
    taskTitle: 'Τίτλος',
    taskTitlePlaceholder: 'π.χ. Έλεγχος επιλεξιμότητας για την πρόσκληση',
    description: 'Περιγραφή',
    resource: 'Σχετικός πόρος',
    resourceHint: 'Προαιρετικό. Μόνο πόροι αυτής της συλλογής.',
    noResource: 'Χωρίς σύνδεση με πόρο',
    assignees: 'Ανάδοχοι',
    assigneesHint: 'Μόνο μέλη αυτής της συλλογής.',
    noAssignees: 'Χωρίς ανάδοχο',
    dueDate: 'Προθεσμία',
    noDueDate: 'Χωρίς προθεσμία',
    overdue: 'Έληξε',

    save: 'Αποθήκευση',
    saving: 'Αποθήκευση…',
    cancel: 'Ακύρωση',
    close: 'Κλείσιμο',
    edit: 'Επεξεργασία',

    remove: 'Διαγραφή',
    removeTitle: 'Διαγραφή καθηκόντος',
    // ΜΛΑ-03: η προειδοποίηση λέει **τι χάνεται**, πριν από τη μη αναστρέψιμη
    // ενέργεια. Το πλήθος των σημειώσεων μπαίνει από το συστατικό.
    removeWarning: 'Η ενέργεια δεν αναιρείται. Μαζί με το καθήκον διαγράφονται και οι σημειώσεις προόδου του.',
    removeConfirm: 'Διαγραφή',

    notes: 'Σημειώσεις προόδου',
    noNotes: 'Καμία σημείωση ακόμη.',
    notePlaceholder: 'Γράψτε μια σημείωση για την πρόοδο…',
    addNote: 'Προσθήκη σημείωσης',

    createdBy: 'Δημιουργήθηκε από',
    onlyAssignees: 'Την κατάσταση και τις σημειώσεις τις ενημερώνουν οι ανάδοχοι ή ο συντονιστής.',

    // ── ΣΕΤ Β: ο πίνακας Kanban (§4.3.4, με παραπομπή στο §2.7) ──────────────
    //
    // Νέο μπλοκ στο τέλος της οικείας ενότητας. Οι **ετικέτες των στηλών** δεν
    // ζουν εδώ: είναι το `status` παραπάνω, και ο πίνακας το διαβάζει.
    boardEmptyColumn: 'Καμία εγγραφή',
    // Το `aria-label` του επιλογέα **ονομάζει το καθήκον**: χωρίς αυτό ο
    // αναγνώστης οθόνης ακούει δώδεκα πανομοιότυπα «Κατάσταση» και δεν ξέρει
    // ποιο αλλάζει.
    boardStatusOf: (title) => `Κατάσταση του καθηκόντος «${title}»`,
    boardOpenOf: (title) => `Άνοιγμα του καθηκόντος «${title}»`,
    // ── Το φίλτρο «μόνο τα δικά μου» (κοινό στις δύο οθόνες καθηκόντων) ──
    //
    // «Δικά μου» σημαίνει **ανατεθειμένα σε εμένα**, όχι «δημιουργημένα από
    // εμένα»: η ΛΑ-20 μιλά για τον ανάδοχο, και ο συντονιστής που δημιουργεί
    // δεκάδες καθήκοντα για άλλους δεν θέλει να τα δει ως δικά του.
    mineOnly: 'Μόνο τα δικά μου',
    // Ο διάλογος του καθηκόντος ανοίγει πλέον σε **ανάγνωση**. Τα τρία κείμενα
    // που το κάνουν κατανοητό: τι πατάς για να γράψεις, τι λέει η κενή περιγραφή,
    // και το «Κλείσιμο» αντί για «Ακύρωση» — δεν ακυρώνεται τίποτα όταν δεν
    // γράφτηκε τίποτα.
    editHint: 'Διπλό κλικ για επεξεργασία',
    noDescription: 'Χωρίς περιγραφή',
    mineOnlyEmpty: 'Δεν σας έχει ανατεθεί κανένα καθήκον εδώ. Πατήστε ξανά το φίλτρο για να δείτε όλα.',
    boardDragHint: 'Σύρετε μια κάρτα σε άλλη στήλη ή αλλάξτε την κατάσταση από τον επιλογέα της.',
    boardChangeFailed: 'Η αλλαγή κατάστασης δεν αποθηκεύτηκε',

    // ── ΣΕΤ Β: η διασυλλογική οθόνη (Απόφαση D29) ───────────────────────────
    //
    // Ο τίτλος είναι **«Καθήκοντα»**, ο ίδιος με το πλαϊνό μενού. Έλεγε «Τα
    // καθήκοντά μου» ενώ το μενού έλεγε «Καθήκοντα» — η ίδια απόκλιση με το
    // «Κλειδιά API»/«Κλειδιά πρόσβασης», και η ταύτιση **ελέγχεται** πλέον από
    // δοκιμή. Ο ελληνικός όρος είναι και ακριβέστερος: το εύρος της οθόνης
    // είναι οι ορατές συλλογές, όχι μόνο όσα μου ανατέθηκαν.
    allCollections: 'Όλες οι συλλογές',
    collectionFilter: 'Συλλογή',
    crossEmpty: 'Κανένα καθήκον στις συλλογές σας.',
    crossIntro: 'Τα καθήκοντα από όλες τις συλλογές που βλέπετε, σε έναν πίνακα.',
    inCollection: 'Στη συλλογή',
    loadingContext: 'Φόρτωση των στοιχείων της συλλογής…',
    loadingContextHint: 'Ο διάλογος ανοίγει μόλις είναι διαθέσιμα τα μέλη και οι πόροι της.',

    // ── ΣΕΤ Δ: η κάρτα και ο διάλογος ξανασχεδιασμένοι ──────────────────────
    //
    // Η **προθεσμία** αποκτά φόντο, οπότε χρειάζεται και εκφώνηση: το χρώμα δεν
    // διαβάζεται από αναγνώστη οθόνης, και «πράσινο» δεν είναι πληροφορία για
    // όποιον δεν το βλέπει (ΜΛΑ-11).
    dueOn: (date) => `Προθεσμία: ${date}`,
    overdueOn: (date) => `Έληξε στις ${date}`,
    // Το πλήθος των σημειώσεων στην κάρτα. Το εικονίδιο μόνο του δεν λέει τι
    // μετρά — η εκφώνηση το λέει ολόκληρο.
    notesCountOf: (count) => `${count} σημειώσεις προόδου`,
    // Ο ανάδοχος ως πρόσωπο πάνω στην κάρτα: εικόνα με υπόδειξη ονόματος.
    assigneeOf: (name) => `Ανάδοχος: ${name}`,
    andMore: (count) => `+${count}`,
    andMoreOf: (count) => `${count} ακόμη ανάδοχοι`,

    // ⚠ **«Ιστορικό», ίδιο με τον διάλογο του πόρου (23/08, ΜΛΑ-02).** Έλεγε
    // «Δραστηριότητα του καθηκόντος» ενώ η **ίδια** λειτουργία —ίδιο συστατικό,
    // ίδια διαδρομή με άλλη παράμετρο του ίδιου φίλτρου— λεγόταν «Ιστορικό» στον
    // πόρο. Ο χρήστης που έμαθε τη μία λέξη έψαχνε τη λέξη και όχι το πράγμα.
    // Η ταύτιση φυλάσσεται πλέον από το `terminology.test.js`.
    taskActivity: 'Ιστορικό',
    taskActivityTitle: 'Ιστορικό του καθήκοντος',
    taskActivityEmpty: 'Καμία καταγεγραμμένη ενέργεια για αυτό το καθήκον ακόμη.',
    addAssignee: 'Προσθήκη',
    removeAssignee: 'Αφαίρεση',
    removeAssigneeOf: (name) => `Αφαίρεση του ${name} από τους αναδόχους`,
    addAssigneeOf: (name) => `Προσθήκη του ${name} στους αναδόχους`
};

// ── P1-7: ροή δραστηριότητας και ειδοποιήσεις ────────────────────────────────
//
// Νέο μπλοκ στο τέλος, κατά τον κανόνα των αρχείων μόνο-προσθήκης. Το
// `export default` δεν ενημερώνεται: η ενημέρωσή του είναι **επεξεργασία** και
// ανήκει στον κλάδο που κατέχει το αρχείο. Τα συστατικά εισάγουν το ονομαστικό
// `ACTIVITY`.
// ── Ρ3: το κείμενο των επιλογέων, όταν δεν έχει επιλεγεί τίποτα ─────────────
//
// ⚠ **Η βιβλιοθήκη το μεταφράζει ΜΟΝΗ ΤΗΣ, από τη γλώσσα του ΠΕΡΙΗΓΗΤΗ.** Σε
// ελληνικό περιηγητή έβγαινε «Επιλέξτε ένα αντικείμενο», σε αγγλικό «Select an
// item». Δηλαδή το κείμενο της διεπαφής **δεν ήταν ιδιότητα της εφαρμογής αλλά
// της μηχανής του χρήστη** — και ο κατάλογος μηνυμάτων δεν το γνώριζε καν.
//
// Είναι το ίδιο σχήμα με τα αχαρτογράφητα μηνύματα σφάλματος: ο κατάλογος
// καλύπτει **ό,τι γράψαμε**, όχι ό,τι **δείχνει** η οθόνη. Η θεραπεία είναι να
// πάψει να υπάρχει προεπιλογή: κάθε επιλογέας δηλώνει το δικό του κείμενο.
export const SELECT_PLACEHOLDER = 'Επιλέξτε…';

// ── Σ2: ο τύπος του πόρου και τα πλήθη της κάρτας ───────────────────────────
//
// ⚠ **Ο ΤΥΠΟΣ ΔΕΝ ΕΙΝΑΙ Η ΠΡΟΕΛΕΥΣΗ.** Η κάρτα δείχνει ήδη εικονίδιο ιστότοπου —
// «ποιος» — πάνω στην εικόνα. Εδώ λέγεται «**τι είδος**»: βίντεο, ήχος,
// σύνδεσμος. Τα δύο συνυπάρχουν και δεν αντικαθιστά το ένα το άλλο.
export const RESOURCE_KIND = {
    labels: {
        video: 'Βίντεο',
        audio: 'Ήχος',
        link: 'Σύνδεσμος',
        // «Άλλο» σημαίνει «η διεύθυνση δεν διαβάζεται», όχι «δεν την αναγνώρισα»:
        // το δεύτερο είναι ο **σύνδεσμος**. Η διάκριση φαίνεται στην οθόνη.
        other: 'Άλλο'
    },
    icons: {
        video: 'fa-solid fa-video',
        audio: 'fa-solid fa-headphones',
        link: 'fa-solid fa-link',
        other: 'fa-solid fa-file'
    }
};

// Τα πλήθη της κάρτας. **Εκφωνούνται ολόκληρα**: ένας αριθμός δίπλα σε εικονίδιο
// δεν λέει τι μετρά σε όποιον δεν βλέπει το εικονίδιο (ΜΛΑ-11).
export const RESOURCE_COUNTS = {
    tags: (n) => `${n} ${n === 1 ? 'ετικέτα' : 'ετικέτες'}`,
    comments: (n) => `${n} ${n === 1 ? 'σχόλιο' : 'σχόλια'} σε αυτή τη συλλογή`,
    ratings: (n) => `${n} ${n === 1 ? 'αξιολόγηση' : 'αξιολογήσεις'} σε αυτή τη συλλογή`,
    related: (n) => `${n} ${n === 1 ? 'συσχέτιση' : 'συσχετίσεις'}`
};

export const ACTIVITY = {
    feedTitle: 'Δραστηριότητα της συλλογής',
    feedEmpty: 'Καμία καταγεγραμμένη ενέργεια σε αυτή τη συλλογή ακόμη.',
    feedError: 'Η ροή δραστηριότητας δεν φορτώθηκε.',

    notificationsTitle: 'Ειδοποιήσεις',
    notificationsIntro: 'Ενέργειες που σας αφορούν στις συλλογές σας.',
    notificationsEmpty: 'Δεν υπάρχει καμία ειδοποίηση για εσάς.',
    unreadEmpty: 'Δεν υπάρχει καμία αδιάβαστη ειδοποίηση.',
    notificationsError: 'Οι ειδοποιήσεις δεν φορτώθηκαν.',

    onlyUnread: 'Μόνο αδιάβαστες',
    all: 'Όλες',
    markRead: 'Σήμανση ως αναγνωσμένης',

    // ΚΔ3: η μαζική σήμανση. Το κείμενο της επιβεβαίωσης **ονομάζει το πλήθος**
    // (ΜΛΑ-03): μαζική ενέργεια χωρίς μέγεθος αφήνει τον χρήστη να μαντεύει τι
    // πρόκειται να πατήσει.
    markAll: 'Διαβάστηκαν όλες',
    markAllTitle: 'Σήμανση όλων ως αναγνωσμένων',
    markAllWarning: (count) =>
        `${count} ${count === 1 ? 'ειδοποίηση θα σημειωθεί' : 'ειδοποιήσεις θα σημειωθούν'} ως αναγνωσμένες. Η ενέργεια δεν αναιρείται.`,
    markAllNone: 'Δεν υπάρχει καμία αδιάβαστη ειδοποίηση για σήμανση.',
    markAllConfirm: 'Σήμανση όλων',
    markAllCancel: 'Ακύρωση',
    markAllCounting: 'Μέτρηση…',
    markAllFailed: 'Η μαζική σήμανση δεν ολοκληρώθηκε.',
    marking: 'Γίνεται σήμανση…',
    markError: 'Η σήμανση δεν ολοκληρώθηκε.',
    unread: 'Αδιάβαστη',
    unreadBadgeLabel: 'αδιάβαστες ειδοποιήσεις',

    // Η **απόδοση επιμέλειας** (ΛΑ-23): η ίδια ροή, φιλτραρισμένη σε έναν πόρο.
    resourceHistory: 'Ιστορικό του πόρου',
    resourceHistoryEmpty: 'Καμία καταγεγραμμένη μεταβολή αυτού του πόρου σε αυτή τη συλλογή.',

    /**
     * Τι έκανε ο δράστης, ανά είδος γεγονότος. Η γραμμή διαβάζεται ως
     * «{όνομα} {φράση}», δηλαδή «Η Άννα καταχώρησε τον πόρο».
     *
     * **Το `resource.updated_elsewhere` έχει σκόπιμα άλλη διατύπωση** από το
     * `resource.updated`, και δεν είναι ζήτημα ύφους: «κάτι που σε αφορά άλλαξε
     * ΑΛΛΟΥ» δεν είναι το ίδιο γεγονός με «κάτι άλλαξε ΕΔΩ». Ο αναγνώστης δεν
     * πρέπει να νομίσει ότι η επεξεργασία έγινε στη δική του ομάδα. Και **δεν
     * ονομάζει ποια** συλλογή: θα ήταν συναγωγή ύπαρξης (D9).
     */
    verbs: {
        // ⚠ **ΤΟ `{}` ΕΙΝΑΙ Η ΘΕΣΗ ΤΟΥ ΑΝΤΙΚΕΙΜΕΝΟΥ, ΚΑΙ ΕΙΝΑΙ ΥΠΟΧΡΕΩΤΙΚΟ.**
        //
        // Η προηγούμενη μορφή ήταν φράση **χωρίς** θέση, και η γραμμή έβαζε το
        // όνομα του αντικειμένου **πάντοτε στο τέλος**. Για τις περισσότερες
        // φράσεις αυτό ήταν σωστό κατά τύχη — τελείωναν στο ίδιο το αντικείμενο.
        // Για **επτά** δεν ήταν: τελείωναν σε **άλλο** ουσιαστικό, και το όνομα
        // κολλούσε πάνω του. «πρόσθεσε μέλος στη συλλογή «annamaria»» διαβάζεται
        // ως όνομα **της συλλογής**.
        //
        // Δεν ήταν επτά κακές διατυπώσεις: ήταν **μία** λανθασμένη παραδοχή —
        // ότι το αντικείμενο πάει πάντοτε τελευταίο— που έτυχε να ισχύει στις
        // υπόλοιπες. Γι' αυτό η θεραπεία δεν είναι διόρθωση φράσεων αλλά
        // **αφαίρεση της παραδοχής**: κάθε φράση δηλώνει η ίδια πού μπαίνει το
        // αντικείμενό της.
        //
        // Φράση **χωρίς** `{}` σημαίνει γεγονός που δεν φέρνει όνομα. Η
        // αντιστοιχία με το φορτίο του καταλόγου ελέγχεται από δοκιμή, ώστε ούτε
        // η μία ούτε η άλλη περίπτωση να μπορεί να ξεχαστεί.
        //
        // **Το `resource.updated_elsewhere` έχει σκόπιμα άλλη διατύπωση** από το
        // `resource.updated`, και δεν είναι ζήτημα ύφους: «κάτι που σε αφορά
        // άλλαξε ΑΛΛΟΥ» δεν είναι το ίδιο γεγονός με «κάτι άλλαξε ΕΔΩ». Και **δεν
        // ονομάζει ποια** συλλογή: θα ήταν συναγωγή ύπαρξης (D9). Με το όνομα
        // κολλημένο στο τέλος, η προστασία αυτή **έπεφτε στην ανάγνωση** —
        // «…από άλλη συλλογή «Χ»» διαβάζεται ακριβώς ως το όνομα που η απόφαση
        // απαγορεύει να δοθεί.
        'resource.created': 'καταχώρησε τον πόρο {}',
        'resource.attached': 'εντάξε στη συλλογή τον υπάρχοντα πόρο {}',
        'resource.updated': 'ενημέρωσε τα στοιχεία του πόρου {}',
        'resource.updated_elsewhere': 'ενημέρωσε από άλλη συλλογή τα στοιχεία του πόρου {}',
        'resource.detached': 'αφαίρεσε από τη συλλογή τον πόρο {}',
        'resource.deleted': 'διέγραψε οριστικά τον πόρο {}',
        // ΛΑ-12. Το ρήμα είναι **ουδέτερο ως προς την κατεύθυνση**: η σχέση
        // γράφεται σε μία πλευρά αλλά διαβάζεται αμφίδρομα, οπότε «πρόσθεσε στον
        // πόρο» θα ήταν λάθος για τον μισό κόσμο που τη βλέπει.
        'resource.related': 'δήλωσε συσχέτιση του πόρου {}',

        // ⚠ **Β2: ΤΟ ΟΝΟΜΑ ΤΟΥ ΠΟΡΟΥ ΕΡΧΕΤΑΙ ΑΠΟ ΤΗΝ ΑΝΑΓΝΩΣΗ, ΟΧΙ ΑΠΟ ΤΟ
        // ΦΟΡΤΙΟ.** Η γραμμή έλεγε «σχολίασε πόρο» χωρίς να τον ονομάζει, και ο
        // αναγνώστης έπρεπε να ψάξει ποιον. Ο τίτλος **δεν** μπήκε στο
        // αποθηκευμένο γεγονός: εκείνο γράφεται μία φορά για όλους και δεν
        // φιλτράρεται ανά αναγνώστη (§Α58). Τον προσθέτει ο εξυπηρετητής στην
        // ανάγνωση, περνώντας τον από τον **ίδιο** φράχτη ορατότητας με τις
        // συσχετίσεις — αν ο αναγνώστης δεν βλέπει τον πόρο, δεν έρχεται.
        //
        // Γι' αυτό υπάρχει και η αόριστη μορφή παρακάτω: η φράση **πρέπει** να
        // στέκει χωρίς όνομα, αλλιώς η προστασία θα ήταν κενή γραμμή.
        'comment.created': 'σχολίασε τον πόρο {}',
        'rating.created': 'κατέγραψε εκτίμηση συνάφειας για τον πόρο {}',
        // Η αξιολόγηση **δεν** ονομάζει τον πόρο, και δεν είναι παράλειψη: είναι
        // **κρίση**, και το μοντέλο λέει «κοινά τα δεδομένα, ιδιωτικές οι
        // κρίσεις». Το σχόλιο είναι συνομιλία και δείχνει πού γίνεται· η
        // εκτίμηση συνάφειας του Χ για τον πόρο Ψ είναι άλλο πράγμα.
        'rating.updated': 'μετέβαλε την εκτίμηση συνάφειάς του για τον πόρο {}',

        'task.created': 'δημιούργησε το καθήκον {}',
        'task.assigned': 'ανέθεσε το καθήκον {}',
        'task.status_changed': 'άλλαξε την κατάσταση του καθηκόντος {}',
        'task.completed': 'ολοκλήρωσε το καθήκον {}',
        'task.note_added': 'πρόσθεσε σημείωση στο καθήκον {}',
        // Ήρθε από το P1-4 και η φράση του γράφτηκε στη ΣΥΓΧΩΝΕΥΣΗ: ο φράχτης
        // ισότητας το ονόμασε πριν το δει χρήστης. Χωρίς αυτόν, η ροή θα έδειχνε
        // το κυριολεκτικό «task.deleted» δίπλα στο όνομα ενός συναδέλφου.
        'task.deleted': 'διέγραψε το καθήκον {}',

        // ⚠ **Ο ΡΟΛΟΣ ΔΕΝ ΑΝΑΦΕΡΕΤΑΙ, ΚΑΙ ΕΙΝΑΙ ΔΗΛΩΜΕΝΗ ΕΛΛΕΙΨΗ.** Η φράση θα
        // ήταν πληρέστερη ως «πρόσθεσε ως συντονιστή τον χρήστη …», αλλά το
        // γεγονός `member.added` **δεν κουβαλάει τον ρόλο** στο φορτίο του: αυτό
        // φέρει αναγνωριστικό και όνομα χρήστη, τίποτε άλλο. Η προσθήκη πεδίου
        // είναι μεταβολή του **συμβολαίου** —το γεγονός είναι εξωτερικεύσιμο,
        // άρα φεύγει σε τρίτα συστήματα— και δεν γίνεται ως παρενέργεια
        // διόρθωσης διατύπωσης.
        'member.added': 'πρόσθεσε στη συλλογή τον χρήστη {}',
        'member.removed': 'αφαίρεσε από τη συλλογή τον χρήστη {}',
        'member.role_changed': 'μετέβαλε τον ρόλο του μέλους {}',

        'collection.created': 'δημιούργησε τη συλλογή {}',
        'collection.updated': 'επεξεργάστηκε τα στοιχεία της συλλογής {}',
        'collection.deleted': 'διέγραψε τη συλλογή {}',
        'collection.archived': 'αρχειοθέτησε τη συλλογή {}',
        'collection.unarchived': 'επανέφερε από το αρχείο τη συλλογή {}',

        // Δεύτερο πρόσωπο: ο παραλήπτης **είναι** το αντικείμενο. Το όνομα
        // μπαίνει ρητά, γιατί η ίδια γραμμή διαβάζεται και στη ροή από τρίτον.
        'user.promoted': 'όρισε καθολικό διαχειριστή τον χρήστη {}',
        'user.demoted': 'αφαίρεσε τον καθολικό ρόλο από τον χρήστη {}',
        // ΛΑ-01. **Παθητική φωνή, και είναι σκόπιμη:** την επαναφορά την ξεκινά
        // όποιος κρατά τον σύνδεσμο, που **δεν είναι κατ' ανάγκη** ο κάτοχος —
        // αυτός ακριβώς είναι ο λόγος που η ειδοποίηση υπάρχει. «Επανέφερε τον
        // κωδικό του» θα ισχυριζόταν κάτι που το σύστημα δεν γνωρίζει.
        'user.password_reset': 'άλλαξε ο κωδικός πρόσβασης του λογαριασμού {}',
        // feat/email-change — ΛΑ-02 / D45. **Παθητική φωνή για τον ίδιο ακριβώς
        // λόγο με την επαναφορά:** το αίτημα το ξεκινά όποιος κρατά τη συνεδρία,
        // που **δεν είναι κατ' ανάγκη** ο κάτοχος — αυτός είναι ο λόγος που η
        // ειδοποίηση υπάρχει. Και **καμία διεύθυνση στη φράση**: ούτε η παλιά
        // ούτε η νέα. Η γραμμή αποθηκεύεται **μία φορά για όλους** τους
        // αναγνώστες της, οπότε δεν φιλτράρεται ανά αναγνώστη (ίδιο επιχείρημα
        // με το `summary` της D40).
        'user.email_changed': 'άλλαξε η ηλεκτρονική διεύθυνση του λογαριασμού {}',

        // Χωρίς `{}`: το φορτίο φέρει `label` και `url`, όχι `title`/`username`.
        // Είναι **δηλωμένο κενό** και όχι παράλειψη — βλ. §Α48δ του Κεφαλαίου 6.
        'apikey.created': 'εξέδωσε κλειδί πρόσβασης',
        'apikey.revoked': 'ανακάλεσε κλειδί πρόσβασης',
        'apikey.deleted': 'διέγραψε ανακλημένο κλειδί πρόσβασης',
        'webhook.created': 'δημιούργησε συνδρομή γεγονότων',
        'webhook.updated': 'μετέβαλε συνδρομή γεγονότων',
        'webhook.deleted': 'διέγραψε συνδρομή γεγονότων'
    },

    /**
     * ⚠ **Η ΑΟΡΙΣΤΗ ΜΟΡΦΗ, ΓΙΑ ΦΡΑΣΕΙΣ ΠΟΥ ΠΑΙΡΝΟΥΝ ΤΟ ΟΝΟΜΑ ΣΤΗΝ ΑΝΑΓΝΩΣΗ.**
     *
     * Οι φράσεις χωρίζονταν σε **δύο** κατηγορίες: εκείνες που φέρνουν όνομα από
     * το φορτίο του γεγονότος, και εκείνες που δεν φέρνουν ποτέ. Το σχόλιο
     * εισάγει **τρίτη**: το όνομα υπάρχει, αλλά **δεν ζει στο φορτίο** — το
     * προσθέτει ο εξυπηρετητής στην ανάγνωση, αφού κρίνει αν ο **συγκεκριμένος**
     * αναγνώστης δικαιούται να το δει.
     *
     * Άρα η φράση πρέπει να στέκει **και με όνομα και χωρίς**, και οι δύο μορφές
     * γράφονται ρητά. Χωρίς αυτό, ο αναγνώστης που δεν δικαιούται το όνομα θα
     * έβλεπε «σχολίασε τον πόρο» και τίποτα — πρόταση που σταματά στη μέση, και
     * που ο ίδιος ο φράχτης απαγορεύει για τις άλλες φράσεις.
     *
     * *Η αόριστη γραμμή δεν είναι υποβάθμιση· είναι η σωστή γραμμή για εκείνον
     * τον αναγνώστη.*
     */
    verbsWithoutName: {
        'comment.created': 'σχολίασε πόρο',
        // Οι δύο εκτιμήσεις μπήκαν 23/08, μαζί με το όνομα στη φράση τους. Η
        // αόριστη μορφή είναι **υποχρεωτική** και όχι διακοσμητική: με τη D9 ο
        // πόρος είναι κοινός, οπότε υπάρχουν αναγνώστες της ίδιας γραμμής που
        // **δεν δικαιούνται** τον τίτλο — και για εκείνους η πρόταση πρέπει να
        // στέκει ολόκληρη, αντί να τελειώνει σε κενό.
        'rating.created': 'κατέγραψε εκτίμηση συνάφειας για πόρο',
        'rating.updated': 'μετέβαλε την εκτίμηση συνάφειάς του για πόρο'
    },

    /** Εικονίδιο ανά **οικογένεια** γεγονότος, όχι ανά γεγονός. */
    icons: {
        resource: 'fa-solid fa-link',
        comment: 'fa-solid fa-comment',
        rating: 'fa-solid fa-star-half-stroke',
        task: 'fa-solid fa-list-check',
        user: 'fa-solid fa-user',
        collection: 'fa-solid fa-layer-group',
        removal: 'fa-solid fa-trash',
        apikey: 'fa-solid fa-key',
        webhook: 'fa-solid fa-tower-broadcast'
    },

    unknownActor: 'Διαγραμμένος χρήστης',
    /**
     * Η ίδια ενέργεια σε περισσότερες από μία συλλογές.
     *
     * Το πλήθος είναι **των ορατών** συλλογών, γιατί το ερώτημα φιλτράρει πριν
     * ομαδοποιήσει: ο αναγνώστης μαθαίνει μόνο για συλλογές στις οποίες ήδη
     * συμμετέχει. Οι **ονομασίες** τους παραλείπονται — ο χάρτης ενός κοινού
     * πόρου είναι το ένα βήμα που λείπει για να μαντέψει κανείς πού αλλού
     * υπάρχει (D9).
     */
    inSeveral: (count) => `σε ${count} από τις συλλογές σας`
};

/**
 * ΛΑ-28: η σημασιολογική εξαγωγή, στη διεπαφή.
 *
 * Νέο μπλοκ στο τέλος, κατά τον κανόνα των αρχείων μόνο-προσθήκης.
 *
 * Ο όρος είναι **«εξαγωγή»** και όχι «λήψη»: το ζητούμενο δεν είναι να αποκτήσει ο
 * χρήστης ένα αρχείο αλλά να **βγουν τα δεδομένα σε δομημένη μορφή** που διαβάζει
 * άλλο σύστημα. Το ότι φτάνει ως αρχείο είναι ο μηχανισμός, όχι ο σκοπός.
 */
export const EXPORT = {
    cardTitle: 'Διάθεση δεδομένων',
    intro: 'Δομημένη εξαγωγή κατά Schema.org, για ανάγνωση από τρίτα συστήματα.',
    action: 'Εξαγωγή JSON-LD',
    failed: 'Η εξαγωγή απέτυχε'
};

/**
 * ΜΛΑ-03: η επιβεβαίωση διαγραφής συλλογής, **με πλήθη**.
 *
 * Νέο μπλοκ στο τέλος, κατά τον κανόνα των αρχείων μόνο-προσθήκης.
 *
 * Η προηγούμενη διατύπωση προειδοποιούσε χωρίς να ποσοτικοποιεί: έλεγε ότι
 * «αφαιρούνται και οι πόροι που δεν ανήκουν σε καμία άλλη συλλογή» — αληθές, και
 * χωρίς κανέναν αριθμό. Ο χρήστης δεν είχε τρόπο να ξέρει αν αυτό σημαίνει τρεις
 * πόρους ή τριακόσιους, μηδέν σχόλια ή τα σχόλια ολόκληρης της ομάδας.
 *
 * **Ονομάζονται μόνο τα μη μηδενικά.** Κατάλογος με πέντε μηδενικά κρύβει τον έναν
 * αριθμό που δεν είναι μηδέν, και είναι ο μόνος που έχει σημασία. Το ίδιο πρότυπο
 * με την προειδοποίηση αποσύνδεσης πόρου (D13), που ήδη το κάνει.
 */
export const COLLECTION_REMOVAL = {
    title: 'Διαγραφή της συλλογής;',
    counting: 'Γίνεται καταμέτρηση όσων θα χαθούν…',
    // Η μέτρηση απέτυχε: ο διάλογος **δεν** εφευρίσκει μηδενικά. «Κανένα πλήθος»
    // και «μηδέν» είναι διαφορετικές πληροφορίες, και η δεύτερη θα ήταν ψέμα.
    countingFailed: 'Τα πλήθη δεν φορτώθηκαν, οπότε δεν είναι γνωστό τι θα χαθεί.',
    nothingLost: 'Δεν χάνεται τίποτα άλλο: η συλλογή δεν έχει πόρους, κρίσεις, καθήκοντα ή κλειδιά πρόσβασης.',
    irreversible: 'Η ενέργεια δεν αναστρέφεται.',
    cancel: 'Ακύρωση',
    confirm: 'Διαγραφή',

    /**
     * Η φράση των πληθών, με **ελληνικό ενικό και πληθυντικό** ανά είδος.
     *
     * Τα κλειδιά πρόσβασης έχουν δικό τους ρήμα: **ανακαλούνται**, δεν διαγράφονται
     * (D23). Το έγγραφο επιβιώνει επειδή το αντίγραφο του μυστικού σε ξένο μηχάνημα
     * δεν εξαφανίζεται με τη συλλογή, και η φράση δεν επιτρέπεται να υπόσχεται
     * διαγραφή που δεν συμβαίνει.
     */
    summaryOf({ resources = 0, comments = 0, ratings = 0, tasks = 0, apiKeys = 0, webhooks = 0 } = {}) {
        const lost = [];
        if (resources > 0) lost.push(plural(resources, 'πόρος', 'πόροι'));
        if (comments > 0) lost.push(plural(comments, 'σχόλιο', 'σχόλια'));
        if (ratings > 0) lost.push(plural(ratings, 'αξιολόγηση', 'αξιολογήσεις'));
        if (tasks > 0) lost.push(plural(tasks, 'καθήκον', 'καθήκοντα'));

        const parts = [];
        if (lost.length > 0) parts.push(`Διαγράφονται ${joinGreek(lost)}.`);
        if (apiKeys > 0) parts.push(`Ανακαλούνται ${plural(apiKeys, 'κλειδί πρόσβασης', 'κλειδιά πρόσβασης')}.`);
        // **D23, δεύτερη εφαρμογή (21/08).** Ίδιο ρήμα με τα κλειδιά, και για τον
        // ίδιο λόγο: η συνδρομή κρατά μυστικό υπογραφής και διεύθυνση τρίτου
        // συστήματος, δηλαδή είναι διαπιστευτήριο. Το έγγραφο **επιβιώνει** —
        // μαζί του το ιστορικό παραδόσεων — και η φράση δεν επιτρέπεται να
        // υπόσχεται διαγραφή που δεν συμβαίνει.
        if (webhooks > 0) parts.push(`Ανακαλούνται ${plural(webhooks, 'συνδρομή γεγονότων', 'συνδρομές γεγονότων')}.`);

        return parts;
    },

    /**
     * Η διευκρίνιση για τους πόρους, **όταν υπάρχουν πόροι που δεν σβήνουν**.
     *
     * Ο αριθμός μετρά όσους **σβήνουν οριστικά** (D1). Χωρίς αυτή τη γραμμή, ο
     * χρήστης που βλέπει «διαγράφονται 2 πόροι» σε συλλογή με είκοσι κάρτες
     * συμπεραίνει ότι ο αριθμός είναι λάθος — και έχει δίκιο να το συμπεράνει,
     * γιατί τίποτα στην οθόνη δεν του λέει ότι οι υπόλοιποι ζουν αλλού.
     */
    sharedNote: 'Οι πόροι που ανήκουν και σε άλλη συλλογή δεν διαγράφονται· αφαιρούνται μόνο από αυτήν.'
};

/** «και» πριν από το τελευταίο στοιχείο, όπως το γράφει άνθρωπος. */
function joinGreek(parts) {
    if (parts.length <= 1) return parts.join('');
    return `${parts.slice(0, -1).join(', ')} και ${parts[parts.length - 1]}`;
}

/**
 * Οθόνη μελών της ομάδας (Πίνακας 1, `user:manage`).
 *
 * Νέο μπλοκ στο τέλος, κατά τον κανόνα των αρχείων μόνο-προσθήκης.
 *
 * **Ο τίτλος λέει «Μέλη της ομάδας» και όχι «Χρήστες».** Η οθόνη δείχνει τους
 * λογαριασμούς του συστήματος, που στην πιλοτική είναι τα μέλη των ερευνητικών
 * ομάδων ενός ιδρύματος — όχι άγνωστο κοινό. Το «Χρήστες» θα ήταν τεχνικά ακριβές
 * και θα περιέγραφε άλλο σύστημα.
 */
export const USERS = {
    title: 'Μέλη της ομάδας',
    intro: 'Οι λογαριασμοί του συστήματος. Ο καθολικός ρόλος διαχειριστή ισχύει σε όλες τις συλλογές.',

    search: 'Αναζήτηση',
    searchPlaceholder: 'όνομα, ονοματεπώνυμο ή διεύθυνση',
    empty: 'Κανένας λογαριασμός δεν ταιριάζει με την αναζήτηση.',
    loadError: 'Ο κατάλογος των μελών δεν φορτώθηκε.',
    // ⚠ **Δεύτερη ετικέτα, και δεν είναι πλεονασμός.** Η `loadError`
    // χρησιμοποιούνταν **και** ως τίτλος του σφάλματος μιας ενέργειας μέσα στον
    // διάλογο: η άρνηση ενός υποβιβασμού εμφανιζόταν ως «Ο κατάλογος των μελών
    // δεν φορτώθηκε» — για κατάλογο που είχε φορτώσει μια χαρά.
    //
    // Είναι το μοτίβο των δύο διατυπώσεων **αντεστραμμένο**: εκεί ο ίδιος
    // κανόνας γράφεται δύο φορές και οι δύο αποκλίνουν· εδώ μία διατύπωση
    // εξυπηρετεί δύο πράγματα, και είναι λάθος για το ένα από τη στιγμή που
    // γράφεται.
    actionError: 'Η ενέργεια δεν ολοκληρώθηκε.',
    noun: 'μέλη',

    promote: 'Ορισμός διαχειριστή',
    demote: 'Αφαίρεση ρόλου διαχειριστή',
    // Ο ίδιος ο συνδεδεμένος: η ενέργεια δεν αποδίδεται καθόλου, και η γραμμή λέει
    // γιατί. Κουμπί που υπάρχει και αρνείται πάντα είναι χειρότερο από απουσία.
    you: 'Εσείς',

    promoteTitle: 'Ορισμός καθολικού διαχειριστή;',
    promoteBody:
        'Ο λογαριασμός θα αποκτήσει πλήρη δικαιώματα σε ΚΑΘΕ συλλογή του συστήματος, ' +
        'συμπεριλαμβανομένων των ιδιωτικών στις οποίες δεν είναι μέλος, και θα μπορεί να ' +
        'διαχειρίζεται λογαριασμούς και κλειδιά πρόσβασης.',
    demoteTitle: 'Αφαίρεση του ρόλου διαχειριστή;',
    demoteBody:
        'Ο λογαριασμός θα διατηρήσει μόνο τους ρόλους που έχει μέσα στις συλλογές του. ' +
        'Η ενέργεια αναιρείται με νέο ορισμό.',
    confirm: 'Επιβεβαίωση',
    cancel: 'Ακύρωση',

    // Η δημιουργία λογαριασμού **δεν** γίνεται από εδώ: υπάρχει η εγγραφή και δεν
    // διπλασιάζεται. Η γραμμή το λέει, ώστε η απουσία να διαβάζεται ως απόφαση.
    noCreate: 'Οι λογαριασμοί δημιουργούνται από τη σελίδα εγγραφής και όχι από εδώ.'
};

/**
 * Συνδρομές γεγονότων προς τρίτα συστήματα (ΛΑ-27, P2-1).
 *
 * Νέο μπλοκ στο τέλος, κατά τον κανόνα των αρχείων μόνο-προσθήκης.
 *
 * **Ο όρος είναι «Συνδρομές γεγονότων» και όχι «Webhooks».** Η απαίτηση τα
 * ονομάζει συνδρομές, το μοντέλο του εξυπηρετητή επίσης, και σε διεπαφή που είναι
 * ολόκληρη στα ελληνικά το «webhook» είναι αμετάφραστο — ο ίδιος λόγος που τα
 * «Κλειδιά API» έγιναν «Κλειδιά πρόσβασης».
 *
 * **Απορρίφθηκε το «Ειδοποιήσεις σε τρίτα συστήματα»:** η εφαρμογή έχει ήδη οθόνη
 * **Ειδοποιήσεις**, που είναι εντελώς άλλο πράγμα — η κατάσταση ανάγνωσης ενός
 * γεγονότος από έναν χρήστη. Δύο διαφορετικά πράγματα με τον ίδιο όρο είναι
 * ακριβώς το εύρημα της ετικέτας που εξυπηρετούσε δύο σκοπούς.
 */
export const WEBHOOKS = {
    title: 'Συνδρομές γεγονότων',
    intro:
        'Κάθε συνδρομή στέλνει τα επιλεγμένα γεγονότα μιας συλλογής σε διεύθυνση τρίτου συστήματος, υπογεγραμμένα με μυστικό.',

    collection: 'Συλλογή',
    collectionHint: 'Η συνδρομή αφορά μία συλλογή. Τα γεγονότα των υπολοίπων δεν φεύγουν.',
    url: 'Διεύθυνση παράδοσης',
    urlHint: 'Δημόσια διεύθυνση http ή https. Διευθύνσεις του ίδιου μηχανήματος ή εσωτερικού δικτύου απορρίπτονται.',
    events: 'Τύποι γεγονότος',
    // ΚΕ: τα μηνύματα της επικύρωσης, **ανά πεδίο**. Η φόρμα δεν είχε κανένα:
    // το κουμπί έμενε ανενεργό και ο χρήστης δεν μάθαινε ποτέ γιατί.
    needCollection: 'Επιλέξτε συλλογή.',
    needUrl: 'Η διεύθυνση παράδοσης είναι υποχρεωτική.',
    badUrl: 'Δώστε πλήρη διεύθυνση http ή https.',
    localUrl: 'Η διεύθυνση δείχνει στο ίδιο το μηχάνημα ή σε εσωτερικό δίκτυο. Ο εξυπηρετητής θα την απέρριπτε.',
    needEvent: 'Επιλέξτε τουλάχιστον έναν τύπο γεγονότος.',
    noEventTypes: 'Δεν βρέθηκε κανένας τύπος γεγονότος',
    noEventTypesHint: 'Ο κατάλογος των εξωτερικεύσιμων γεγονότων ήρθε άδειος. Καμία συνδρομή δεν μπορεί να δημιουργηθεί — είναι σφάλμα της εφαρμογής, όχι της συμπλήρωσης.',

    eventsHint: 'Μόνο τα γεγονότα που επιτρέπεται να φύγουν από το σύστημα. Τα υπόλοιπα είναι εσωτερικά.',
    create: 'Δημιουργία συνδρομής',
    creating: 'Γίνεται δημιουργία…',

    /**
     * Τα ονόματα των τύπων, ως **ουσιαστικά**.
     *
     * Δεν επαναχρησιμοποιούνται οι φράσεις της ροής δραστηριότητας, και δεν είναι
     * αβλεψία: εκείνες είναι **ρήματα σε πρόταση** («καταχώρησε τον πόρο»), γιατί
     * εκεί ο χρήστης είναι το υποκείμενο. Εδώ ο τύπος είναι **αντικείμενο
     * επιλογής** σε λίστα, και «☐ καταχώρησε τον πόρο» δεν διαβάζεται.
     *
     * Ο **κατάλογος** των τύπων δεν γράφεται εδώ: διαβάζεται από τη μοναδική πηγή
     * του εξυπηρετητή. Εδώ ζουν μόνο τα **ονόματα**, και δοκιμή επιβεβαιώνει ότι
     * υπάρχει όνομα για κάθε εξωτερικεύσιμο τύπο — αλλιώς ένας νέος τύπος θα
     * εμφανιζόταν στη φόρμα με το αγγλικό αναγνωριστικό του.
     */
    eventLabels: {
        'resource.created': 'Καταχώρηση πόρου',
        'resource.updated': 'Ενημέρωση στοιχείων πόρου',
        'task.assigned': 'Ανάθεση καθηκόντος',
        'task.completed': 'Ολοκλήρωση καθηκόντος',
        'member.added': 'Προσθήκη μέλους'
    },

    secretTitle: 'Το μυστικό υπογραφής, μία φορά',
    secretWarning:
        'Αντιγράψτε το τώρα. Δεν εμφανίζεται ξανά και ΔΕΝ μπορεί να αντικατασταθεί: αν χαθεί, η μόνη διέξοδος είναι διαγραφή της συνδρομής και δημιουργία νέας.',
    secretUse: 'Με αυτό επαληθεύει το τρίτο σύστημα την υπογραφή κάθε παράδοσης.',
    copy: 'Αντιγραφή',
    copied: 'Αντιγράφηκε',

    listTitle: 'Συνδρομές',
    empty: 'Καμία συνδρομή. Οι εκπομπές γεγονότων δεν φεύγουν πουθενά.',
    active: 'Ενεργή',
    inactive: 'Ανενεργή',
    createdAt: 'Δημιουργήθηκε',
    lastDelivery: 'Τελευταία παράδοση',
    neverDelivered: 'Καμία παράδοση ακόμη',
    owner: 'Δημιουργός',

    // ⚠ **Η ΟΡΦΑΝΗ ΕΠΑΨΕ ΝΑ ΥΠΑΡΧΕΙ ΩΣ ΚΑΤΑΣΤΑΣΗ (21/08, D23 δεύτερη εφαρμογή).**
    // Η διαγραφή της συλλογής **ανακαλεί** πλέον τις συνδρομές της, οπότε καμία
    // δεν μένει «ενεργή χωρίς συλλογή». Τα κείμενα μένουν για την περίπτωση
    // παλαιότερης εγγραφής, και λένε πλέον **και τα δύο**: τι έγινε στη συλλογή
    // και τι έγινε στη συνδρομή.
    orphanCollection: 'Η συλλογή δεν υπάρχει πλέον',
    revoked: 'Ανακλημένη',
    revokedHint:
        'Ανακλήθηκε αυτόματα όταν διαγράφηκε η συλλογή της. Δεν παραδίδει πλέον τίποτα και δεν '
        + 'επανενεργοποιείται. Το ιστορικό παραδόσεων παραμένει διαθέσιμο.',
    orphanHint:
        'Η συνδρομή επιβιώνει της διαγραφής της συλλογής της: κρατά το μυστικό υπογραφής και τη διεύθυνση του τρίτου συστήματος. Δεν στέλνει τίποτα, αλλά ούτε ανακαλείται μόνη της.',
    privateNote: 'Ιδιωτική συλλογή: τα γεγονότα φεύγουν μόνο αν ο δημιουργός της συνδρομής είναι συντονιστής της.',

    enable: 'Ενεργοποίηση',
    disable: 'Απενεργοποίηση',
    remove: 'Διαγραφή',
    removeTitle: 'Διαγραφή συνδρομής',
    removeConfirm: 'Διαγραφή',
    cancel: 'Ακύρωση',
    removeWarning: (subscription) =>
        `Σταματούν οριστικά οι παραδόσεις προς ${subscription.url}. Η ενέργεια δεν αναιρείται και το μυστικό υπογραφής χάνεται.`,

    deliveries: 'Παραδόσεις',
    deliveriesOf: (url) => `Παραδόσεις προς ${url}`,
    deliveriesEmpty: 'Καμία παράδοση για αυτή τη συνδρομή.',

    // ⚠ **Ρ2γ: το κενό δεν είναι μία κατάσταση αλλά ΔΥΟ.** «Καμία παράδοση
    // ακόμη» και «η συνδρομή δεν πυροδοτήθηκε ποτέ» φαίνονται ίδια στην οθόνη και
    // σημαίνουν αντίθετα πράγματα: το πρώτο λέει «περίμενε», το δεύτερο «κάτι δεν
    // θα συμβεί ποτέ με αυτή τη ρύθμιση». Ο ελεγκτής που βλέπει κενό δεν έχει
    // τρόπο να ξέρει ποιο από τα δύο ισχύει — και το βήμα Ω8 του ζητά ακριβώς
    // αυτό. Ο κατάλογος παρακάτω απαριθμεί **τι πρέπει να ισχύει** ώστε να
    // υπάρξει παράδοση, ώστε το κενό να γίνεται διαγνώσιμο χωρίς τερματικό.
    deliveriesWhyEmpty: 'Γιατί μπορεί να μην υπάρχει καμία',
    deliveriesWhyInactive: 'Η συνδρομή είναι **ανενεργή**: καμία παράδοση δεν δημιουργείται όσο είναι.',
    deliveriesWhyArchived: 'Η συλλογή είναι **αρχειοθετημένη**: η αρχειοθέτηση παγώνει και το εξωτερικό κανάλι.',
    deliveriesWhyPrivate: 'Η συλλογή είναι **ιδιωτική**: παραδίδεται μόνο αν ο δημιουργός της συνδρομής είναι **συντονιστής** της (D17).',
    deliveriesWhyOrphan: 'Η συλλογή **δεν υπάρχει πλέον**: δεν παράγεται κανένα γεγονός για αυτήν.',
    deliveriesWhyAttached: 'Η καταχώρηση **υπάρχουσας** διεύθυνσης σε δεύτερη συλλογή δεν είναι καταχώρηση πόρου: παράγει **εσωτερικό** γεγονός, που δεν φεύγει ποτέ.',
    deliveriesWhyEvents: (types) => `Πυροδοτούν **μόνο** τα επιλεγμένα γεγονότα: ${types}.`,
    deliveriesNote:
        'Το φορτίο κάθε παράδοσης δεν εμφανίζεται εδώ: η οθόνη απαντά στο «γιατί δεν έφτασε», όχι στο «τι έστελνε».',
    attempts: 'Προσπάθειες',
    attemptsOf: (count) => (count === 1 ? '1 προσπάθεια' : `${count} προσπάθειες`),
    responseStatus: 'Απόκριση',
    failureReason: 'Αιτία αποτυχίας',
    retry: 'Επανάληψη',
    retryQueued: 'Η επανάληψη μπήκε σε ουρά.',
    close: 'Κλείσιμο',

    /** Οι πέντε καταστάσεις παράδοσης, από το μοντέλο του εξυπηρετητή. */
    deliveryStates: {
        pending: 'Σε αναμονή',
        delivering: 'Σε εξέλιξη',
        succeeded: 'Παραδόθηκε',
        failed: 'Απέτυχε',
        suppressed: 'Δεν στάλθηκε'
    },

    subscriptionsNoun: 'συνδρομές'
};

/**
 * ΛΑ-12: συσχετίσεις πόρων.
 *
 * Νέο μπλοκ στο τέλος, κατά τον κανόνα των αρχείων μόνο-προσθήκης.
 */
export const RELATED = {
    title: 'Συσχετισμένοι πόροι',
    intro: 'Πόροι που αφορούν το ίδιο θέμα, την ίδια πρόσκληση, ή συμπληρώνουν ο ένας τον άλλον.',
    empty: 'Καμία συσχέτιση.',
    add: 'Συσχέτιση με πόρο αυτής της συλλογής',
    confirm: 'Προσθήκη',
    noCandidates: 'Δεν υπάρχει άλλος πόρος σε αυτή τη συλλογή για συσχέτιση.',
    failed: 'Η συσχέτιση δεν καταχωρήθηκε',
    // Ο συσχετισμένος πόρος που δεν βρίσκεται στη φορτωμένη σελίδα. Η
    // σελιδοποίηση είναι στον διακομιστή: ο πόρος της πέμπτης σελίδας δεν υπάρχει
    // στη μνήμη του πελάτη, και κενό chip θα διαβαζόταν ως σφάλμα.
    elsewhere: 'Πόρος σε άλλη σελίδα',
    removeOf: (title) => `Αφαίρεση της συσχέτισης με «${title}»`
};

/**
 * P1-5β: τα μεταδεδομένα που απορρίφθηκαν στην προσάρτηση.
 *
 * Νέο μπλοκ στο τέλος, κατά τον κανόνα των αρχείων μόνο-προσθήκης.
 *
 * **Τα ονόματα των πεδίων ζουν εδώ και όχι στο συστατικό**, και η πληρότητά τους
 * απέναντι στον κατάλογο που στέλνει ο εξυπηρετητής φυλάσσεται από δοκιμή: πεδίο
 * χωρίς όνομα θα εμφανιζόταν με το αγγλικό αναγνωριστικό του, σε μήνυμα που
 * υπάρχει ακριβώς για να καταλάβει ο χρήστης τι έχασε.
 */
export const DISCARDED = {
    title: 'Τι δεν αποθηκεύτηκε',
    intro:
        'Η διεύθυνση ήταν ήδη καταχωρημένη, οπότε ισχύουν τα στοιχεία που έχει επιμεληθεί η άλλη ομάδα. Παρακάτω είναι όσα συμπληρώσατε και διαφέρουν.',
    yours: 'Συμπληρώσατε',
    current: 'Ισχύει',
    none: '—',
    forward: 'Προώθηση στην επεξεργασία',
    forwardHint:
        'Ανοίγει τη φόρμα επεξεργασίας του πόρου με τις δικές σας τιμές συμπληρωμένες. Τίποτα δεν αποθηκεύεται μέχρι να πατήσετε αποθήκευση.',

    labels: {
        title: 'Τίτλος',
        description: 'Περιγραφή',
        image: 'Εικόνα',
        tags: 'Ετικέτες',
        'funding.agency': 'Φορέας χρηματοδότησης',
        'funding.field': 'Επιστημονικό πεδίο',
        'funding.deadline': 'Προθεσμία υποβολής',
        'funding.amount': 'Μέγιστη χρηματοδότηση',
        'funding.eligibleEntities': 'Επιλέξιμοι φορείς',
        'funding.terms': 'Βασικοί όροι συμμετοχής'
    }
};

/**
 * Α6: το κουμπί επιστροφής στην κορυφή.
 *
 * Νέο μπλοκ στο τέλος, κατά τον κανόνα των αρχείων μόνο-προσθήκης.
 */
export const BACK_TO_TOP = {
    label: 'Επιστροφή στην κορυφή της σελίδας'
};

/**
 * Β1: σε ποιες συλλογές ανήκει ο πόρος ενός αποτελέσματος αναζήτησης.
 *
 * **Μόνο όσες βλέπει ο αιτών** — το εύρος το ορίζει ο εξυπηρετητής και ο πελάτης
 * δεν έχει τρόπο να το διευρύνει. Η εκφώνηση το λέει ρητά, γιατί ένας κοινός
 * πόρος (D9) μπορεί να ζει και αλλού και ο αριθμός θα διαβαζόταν ως πλήρης.
 */
export const RESULT_COLLECTIONS = {
    label: 'Σε συλλογές που βλέπετε',
    open: (title) => `Άνοιγμα του πόρου στη συλλογή «${title}»`,
    none: 'Σε καμία συλλογή που βλέπετε'
};

/**
 * D44: οι **αναφορές χρήστη** (`@όνομα`) στα πεδία συνομιλίας.
 *
 * Νέο μπλοκ στο τέλος, κατά τον κανόνα των αρχείων μόνο-προσθήκης.
 *
 * ⚠ **Το `mentionedYou` δεν είναι δεύτερη διατύπωση της φράσης του γεγονότος.** Η
 * γραμμή της ροής λέει **τι έγινε** («σχολίασε πόρο») και είναι η ίδια για κάθε
 * αναγνώστη· αυτό λέει **γιατί το βλέπεις εσύ**, και αφορά μόνο τον παραλήπτη που
 * αναφέρθηκε ονομαστικά. Χωρίς αυτό, ο αναφερόμενος θα έβλεπε ακριβώς την ίδια
 * γραμμή με όποιον ειδοποιήθηκε επειδή συμμετέχει στο νήμα, και δεν θα μάθαινε
 * ποτέ ότι τον φώναξαν.
 */
export const MENTIONS = {
    /** Ετικέτα του καταλόγου υπόδειξης, για όποιον ακούει την οθόνη. */
    listLabel: 'Μέλη της συλλογής',
    loading: 'Φόρτωση μελών…',
    hint: 'Γράψτε @ για να αναφέρετε μέλος της συλλογής.',

    /** Η σήμανση πάνω στη γραμμή της ειδοποίησης. */
    mentionedYou: 'Σας ανέφερε',

    /**
     * Η άρνηση, όταν η αναφορά δεν αντιστοιχεί σε μέλος.
     *
     * **Μία διατύπωση για δύο αποτυχίες** —άγνωστο όνομα και υπαρκτός μη μέλος—
     * γιατί ο διαχωρισμός τους θα έκανε τη φόρμα σχολίου εργαλείο απαρίθμησης
     * λογαριασμών. Ονομάζει **ποια** ονόματα, ώστε ο χρήστης να ξέρει τι να
     * διορθώσει· ποτέ **γιατί**.
     */
    notMembers: (names) =>
        names.length === 1
            ? `Το όνομα «@${names[0]}» δεν αντιστοιχεί σε μέλος αυτής της συλλογής.`
            : `Τα ονόματα ${names.map((name) => `«@${name}»`).join(', ')} δεν αντιστοιχούν σε μέλη αυτής της συλλογής.`
};

// feat/history-tags
/**
 * D46: το **ιστορικό του πόρου**, ως τρίτη καρτέλα του διαλόγου του.
 *
 * Νέο μπλοκ στο τέλος, κατά τον κανόνα των αρχείων μόνο-προσθήκης — και όχι
 * κλειδιά μέσα στο υπάρχον `JUDGEMENTS`, όπου ζουν οι δύο άλλες καρτέλες: εκείνο
 * είναι επεξεργασία υπάρχουσας γραμμής και συγκρούεται σε κάθε merge.
 *
 * ⚠ **Το κείμενο της κενής κατάστασης δεν λέει «καμία ενέργεια», λέει «καμία
 * ενέργεια ΣΕ ΑΥΤΗ ΤΗ ΣΥΛΛΟΓΗ».** Με τη **D9** ο πόρος είναι κοινός: το ιστορικό
 * που βλέπει ο αναγνώστης είναι πάντοτε **της συλλογής μέσα από την οποία τον
 * άνοιξε**, ποτέ ολόκληρη η ζωή του πόρου. Κενός κατάλογος χωρίς αυτή τη λέξη
 * διαβάζεται ως «δεν συνέβη τίποτα πουθενά», που είναι **ψευδές** και μάλιστα
 * προς τη μία κατεύθυνση: υπόσχεται πληρότητα την οποία ο φράχτης ορατότητας
 * απαγορεύει να υπάρχει.
 */
export const RESOURCE_HISTORY = {
    tab: 'Ιστορικό',
    title: 'Ιστορικό του πόρου',
    empty: 'Καμία καταγεγραμμένη ενέργεια για αυτόν τον πόρο σε αυτή τη συλλογή ακόμη.'
};

// feat/email-change
//
// ΛΑ-02 / **D45**: η αλλαγή ηλεκτρονικής διεύθυνσης με επιβεβαίωση.
//
// ⚠ **Καμία διατύπωση δεν ονομάζει ολόκληρη την «άλλη» διεύθυνση.** Η ένδειξη
// εκκρεμότητας δείχνει τη νέα **μασκαρισμένη**, όπως έρχεται από τον
// εξυπηρετητή, γιατί ο αναγνώστης της οθόνης είναι ο κάτοχος της **συνεδρίας**
// και όχι κατ' ανάγκην ο κάτοχος του **λογαριασμού** — ακριβώς η περίπτωση για
// την οποία υπάρχει η επιβεβαίωση.
export const EMAIL_CHANGE = {
    action: 'Αλλαγή',
    dialogTitle: 'Αλλαγή διεύθυνσης',
    dialogHint:
        'Η νέα διεύθυνση ενεργοποιείται μόνο αφού την επιβεβαιώσετε από το μήνυμα '
        + 'που θα λάβετε σε αυτήν. Ως τότε ισχύει η τρέχουσα.',
    newEmail: 'Νέα διεύθυνση',
    currentPassword: 'Τρέχων κωδικός πρόσβασης',
    passwordHint: 'Ζητείται επειδή η διεύθυνση είναι ο τρόπος με τον οποίο συνδέεστε.',
    submit: 'Αποστολή επιβεβαίωσης',
    cancel: 'Άκυρο',
    requested: 'Στάλθηκε μήνυμα επιβεβαίωσης.',
    pending: (masked) => `Εκκρεμεί επιβεβαίωση στο ${masked}`,
    pendingHint: 'Η διεύθυνσή σας δεν έχει αλλάξει ακόμη.',
    cancelRequest: 'Ακύρωση αιτήματος',
    cancelled: 'Το αίτημα ακυρώθηκε.',
    readOnly: 'Αλλάζει μόνο με επιβεβαίωση.',

    // Η σελίδα του συνδέσμου.
    confirmTitle: 'Επιβεβαίωση διεύθυνσης',
    confirmSubtitle: 'Επιβεβαιώστε ότι αυτή η διεύθυνση σας ανήκει.',
    // **Κουμπί και όχι αυτόματη υποβολή στο άνοιγμα**, και ο λόγος είναι
    // πρακτικός: οι υπηρεσίες ηλεκτρονικού ταχυδρομείου **προανοίγουν** τους
    // συνδέσμους των μηνυμάτων για έλεγχο ασφαλείας. Με αυτόματη υποβολή, το
    // διακριτικό μίας χρήσης θα καταναλωνόταν από μηχανή πριν το δει άνθρωπος —
    // και ο χρήστης θα έβλεπε «ο σύνδεσμος δεν ισχύει» σε σύνδεσμο που μόλις
    // έφτασε. Ένα πάτημα κοστίζει λιγότερο από μια ροή που αποτυγχάνει σιωπηλά.
    confirmAction: 'Επιβεβαίωση',
    confirmSuccess: 'Η διεύθυνσή σας άλλαξε. Συνδεθείτε με τη νέα διεύθυνση.',
    confirmFailedTitle: 'Ο σύνδεσμος δεν ισχύει',
    backToLogin: 'Επιστροφή στη σύνδεση'
};

// feat/topics
/**
 * D47 και D48: τα **θεματικά αντικείμενα** και οι **προτεινόμενες συλλογές**.
 *
 * Νέο μπλοκ στο τέλος, κατά τον κανόνα των αρχείων μόνο-προσθήκης.
 *
 * ⚠ **Η κενή κατάσταση έχει ΔΥΟ διατυπώσεις, και δεν είναι πλεονασμός.** «Δεν
 * βρέθηκε τίποτε» και «δεν μου είπες τι σε ενδιαφέρει» είναι δύο καταστάσεις με
 * **εντελώς διαφορετική επόμενη ενέργεια**: η πρώτη ζητά υπομονή, η δεύτερη ένα
 * κλικ στο προφίλ. Ένα κοινό μήνυμα θα έστελνε τους μισούς χρήστες να περιμένουν
 * κάτι που δεν πρόκειται να έρθει (ΜΛΑ-03).
 */
export const TOPICS = {
    title: 'Θεματικά αντικείμενα',
    subtitle: 'Το κοινό λεξιλόγιο με το οποίο κατατάσσονται οι συλλογές.',

    name: 'Όνομα',
    description: 'Περιγραφή',
    // Η **λέξη** «δημόσιες» δεν είναι διακόσμηση: ο αριθμός είναι σύνδεσμος και
    // ο προορισμός του δείχνει μόνο δημόσιες συλλογές. Χωρίς αυτήν, ο αριθμός
    // υπόσχεται περισσότερα από όσα ανοίγει.
    collections: (count) => (count === 1 ? '1 δημόσια συλλογή' : `${count} δημόσιες συλλογές`),
    openCollections: (name) => `Οι δημόσιες συλλογές του θέματος «${name}»`,

    create: 'Νέο θεματικό αντικείμενο',
    edit: 'Επεξεργασία',
    save: 'Αποθήκευση',
    cancel: 'Άκυρο',
    remove: 'Διαγραφή',

    // ΜΛΑ-03: η μη αναστρέψιμη ενέργεια **ονομάζει το πλήθος**, και όταν το πλήθος
    // δεν είναι μηδέν λέει ότι η ενέργεια **δεν θα γίνει** — αντί να την αφήσει να
    // αποτύχει στον διακομιστή.
    removeTitle: 'Διαγραφή θεματικού αντικειμένου',
    removeBody: (name) => `Το «${name}» θα διαγραφεί από το λεξιλόγιο. Δεν αναιρείται.`,
    removeBlocked: (name, count) =>
        `Το «${name}» χρησιμοποιείται από ${count === 1 ? '1 συλλογή' : `${count} συλλογές`} `
        + 'και δεν διαγράφεται. Μετονόμασέ το ή άλλαξε πρώτα το θέμα εκείνων των συλλογών.',

    // Η μετονομασία αγγίζει έγγραφα που ο διαχειριστής δεν είδε. Το πλήθος είναι
    // η μόνη ένδειξη ότι συνέβη.
    renamed: (count) =>
        count === 0
            ? 'Το θέμα μετονομάστηκε. Καμία συλλογή δεν το χρησιμοποιούσε.'
            : `Το θέμα μετονομάστηκε, και ενημερώθηκαν ${count === 1 ? '1 συλλογή' : `${count} συλλογές`}.`,

    empty: 'Δεν έχει οριστεί κανένα θεματικό αντικείμενο ακόμη.',
    emptyAdmin: 'Δεν έχει οριστεί κανένα θεματικό αντικείμενο ακόμη. Δημιούργησε το πρώτο.',

    // Ο επιλογέας μέσα στη φόρμα της συλλογής.
    picker: 'Θεματικό αντικείμενο',
    pickerHint: 'Διαλέξτε από όσα χρησιμοποιούνται ήδη:',
    pickerEmpty: 'Δεν υπάρχουν ακόμη θεματικά αντικείμενα.',
    pickerEmptyLink: 'Δες τα θεματικά αντικείμενα',
    clear: 'Καθαρισμός'
};

export const SUGGESTED = {
    title: 'Προτεινόμενες για εσάς',
    // Ο λόγος, πάντοτε ορατός δίπλα στην πρόταση: χωρίς αυτόν η κάρτα είναι
    // αδιάκριτη από σύσταση αλγορίθμου, και το §3.6 ορίζει ότι δεν είναι.
    byTopic: (topic) => `θέμα: ${topic}`,
    byTags: (tags) => `ετικέτες: ${tags.join(', ')}`,

    noInterests:
        'Δεν έχετε δηλώσει θεματικά ή ερευνητικά ενδιαφέροντα, οπότε δεν υπάρχει από τι '
        + 'να προκύψουν προτάσεις.',
    noInterestsLink: 'Συμπλήρωσε τα ενδιαφέροντά σου',
    none: 'Καμία δημόσια συλλογή δεν ταιριάζει προς το παρόν με τα ενδιαφέροντά σας.'
};
